import React, { useState, useContext, useMemo, useRef, useEffect, Fragment } from 'react'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useAliveController } from 'react-activation'
import { Input, Button, Radio, Empty, Modal, message, Spin, Pagination, Segmented, ConfigProvider, Tooltip, InputNumber, Select, Image } from 'antd'
import type { RadioChangeEvent } from 'antd';
import { SearchOutlined, ArrowRightOutlined, BarsOutlined, AppstoreOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons'
import MainContext from '@/stores/stores'
import axios from 'axios'
import { strEncrypt, getDecryptParams, getDecryptParamsKey, roundToTwo, formatVND } from '@/utils/utils'
import { Supplement } from '@/pages/Mine/Company'
import spaceListDefault from '@/assets/img/space_list_default.png'
import spaceListSelected from '@/assets/img/space_list_selected.png'
import textListDefault from '@/assets/img/text_list_default.png'
import textListSelected from '@/assets/img/text_list_selected.png'
import brandSelected from '@/assets/img/brandSelected.png'
import oeIcon from '@/assets/img/oe_icon.png'
import noOeImg from '@/assets/img/no_oe_img.png'
import listApi from '@/api/listApi';
import orderApi from '@/api/orderApi'
import accountApi from '@/api/accountApi';
import replaceIcon from '@/assets/img/replace_icon.png'
import cartPng from '@/assets/img/cartSelect.png'
import Copy from '@/components/Copy'
import { hex_md5 } from '@/utils/md5'
import styles from './index.module.scss'
import vinApi from '@/api/epcApi';
import CurrencyExrate from '@/components/CurrencyExrate'
import VinDomain from './VinDomain'
import ObsImageUpload from '@/components/ObsImageUpload'

const s4 = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
             .toString(16)
             .substring(1);
};
const JsGuid = () => {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
         s4() + '-' + s4() + s4() + s4();
}

let timer: any;
let pidList: any[] = []
let pidAcIndex: number = 0
let batch_id: string = ''
let old_value: string = ''
let change_value: string = ''

const PidList: React.FC = () => {
  const lang = localStorage.getItem("lang") || 'zh'
  const cur = lang === 'ru' ? '₽' : lang === 'en' ? '$' : '￥'
  const navigate = useNavigate()
  const intl = useIntl()
  const { refreshScope, clear, dropScope, drop, refresh  } = useAliveController()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { isWomala, host, pageType, open_new, colorPrimary, fontColorPrimary, showOe } = commonStore
  const token = localStorage.getItem("token") ? localStorage.getItem("token") : ''
  const { pathname } = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  let params = searchParams.get("params")
  const [isCst, setIsCst] = useState<number>(0)
  const [isGetIsCst, setIsGetIsCst] = useState<boolean>(false)
  const [keyword, setKeyword] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [oeHistory, setOeHistory] = useState<any[]>([])
  const [partList, setPartList] = useState<any[]>([])
  const [defaultPartList, setDefaultPartList] = useState<any[]>([])
  const [partKey, setPartKey] = useState<string>('')
  const [partKeyword, setPartKeyword] = useState<string>('')
  const [sortType, setSortType] = useState<string>('default')
  const [listType, setListType] = useState<string>('space') // space  text

  const [ycOeList, setYcOeList] = useState<any[]>([])
  const [oeAcIndex, setOeAcIndex] = useState<number>(0)

  const [supplementOpen, setSupplementOpen] = useState<boolean>(false)
  const [companyInfo, setCompanyInfo] = useState<any>({})

  const [selectArr, setSelectArr] = useState<any[]>([])
  const [selectA, setSelectA] = useState<string>("")

  const [pager, setPager] = useState<any>({
    page: 1,
    size: 60,
    total: 0
  })
  const [pidListParams, setPidListParams] = useState<any>({
    oeListArr: [],
    no_find_oe: []
  })
  const [isMore, setIsMore] = useState<boolean>(false)

  const [itemWidth, setItemWidth] = useState<any>('17.5%')

  const [classList, setClassList] = useState<any[]>([])
  const [classImg, setClassImg] = useState<any[]>([])
  const [selClass, setSelClass] = useState<string>("")
  const [secondClass, setSecondClass] = useState<string>("")
  const [selTags, setSelTags] = useState<string>('')
  const [groupClass, setGroupClass] = useState<any>({})
  const [hasSecondClass, setHasSecondClass] = useState<boolean>(false)
  const [fbrandList, setFbrandList] = useState<any>([])
  const [activeFbrand, setActiveFbrand] = useState<string[]>([])
  const [is_down, set_is_down] = useState<boolean>(true)
  const [_part_list, set_part_list] = useState<any[]>([])

  const [asstShow, setAsstShow] = useState<boolean>(false)
  const [asstInfo, setAsstInfo] = useState<any>({})

  const [translateX, setTranslateX] = useState<number>(0)

  const spacelistRef = useRef<any>(null)


  
  useEffect(() => {
    // getUserInfo()
    getIsCst()
    if(localStorage.getItem('token') && (!localStorage.getItem('tourist_user'))) {
      getOeHistory()
    }
    getClassList()
    getFbrandList()
    return () => {
      clear()
    }
    
  }, [])
  useEffect(() => {
    if(spacelistRef.current) {
      window.addEventListener("resize", function() {
        if(timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          initItemWidth()
        },200)
      })
    }
    return () => {
      clearTimeout(timer)
    }
  }, [spacelistRef.current])
  useEffect(() => {
    set_part_list([])
    if(!selectA) {
      set_part_list(partList)
    }else {
      let part_list = partList.filter((it: any) => it.oe === selectA || it.quality_oe === selectA || it.pid === selectA)
      set_part_list(part_list)
    }
  }, [partList, selectA])
  

  /* useEffect(() => {
    if(commonStore.userInfo && commonStore.userInfo.repair_shop_id) {
      getCompanyInfo()
    }
  }, [commonStore.userInfo]) */
  useEffect(() => {
    const search = window.location.search
    let _params = getDecryptParamsKey(search, 'params')
    let paramsObj = _params ? getDecryptParams(_params) : {oeList: '', class: ''}
    console.log('params:', params, 'pathname:', pathname, "_params:", _params, "paramsObj:", paramsObj, 'keyword:', keyword)
    old_value = change_value
    if(commonStore.pageType !== '6') {
      if(commonStore.userInfo.goods_cst_ids && isGetIsCst) {
        let class1 = ''
        let class2 = ''
        if(paramsObj.class) {
          let _classArr = paramsObj.class.split(',')
          class1 = _classArr[0].replace(/\+/, "&")
          class2 = _classArr[1] ? _classArr[1].replace(/\+/, "&") : ''
          setSelTags('')
          setSelClass(class1)
          setSecondClass(class2)
        }else {
          setSelClass('')
          setSecondClass('')
        }
        if(paramsObj.tags) {
          setSelClass('')
          setSecondClass('')
          setSelTags(paramsObj.tags)
        }else {
          setSelTags('')
        }
        if(keyword !== paramsObj.oeList && _params) {
          let _oeList = paramsObj.oeList ? paramsObj.oeList.split(",") : []
          setKeyword(_oeList.join('\n'))
          if(paramsObj.oeList) {
            if(_oeList.length > 1) {
              setYcOeList(_oeList)
              setOeAcIndex(0)
              pidList = _oeList
              pidAcIndex = 0
              setSelectArr(_oeList)
              /* let _oeList1 = _oeList.length > 20 ? _oeList.slice(0, 20) : _oeList
              let oeList1 = _oeList1.join(',') */
              // getOeListPart(oeList1, true)
              setPager({
                page: 1,
                size: 60,
                total: 0
              })
              getSearchList(_oeList)
            }else {
              // getOnlyOeList(paramsObj.oeList)
              setSelectArr([])
              setPager({
                page: 1,
                size: 60,
                total: 0
              })
              getSearchList([paramsObj.oeList])
            }
          }else {
            getPidList([], [])
          }
        }
      }
    }else {
      if(commonStore.userInfo && commonStore.userInfo.goods_cst_ids && isGetIsCst) {
        let class1 = ''
        let class2 = ''
        if(paramsObj.class) {
          let _classArr = paramsObj.class.split(',')
          class1 = _classArr[0].replace(/\+/, "&")
          class2 = _classArr[1] ? _classArr[1].replace(/\+/, "&") : ''
          setSelTags('')
          setSelClass(class1)
          setSecondClass(class2)
        }else {
          setSelClass('')
          setSecondClass('')
        }
        if(paramsObj.tags) {
          setSelClass('')
          setSecondClass('')
          setSelTags(paramsObj.tags)
        }else {
          setSelTags('')
        }
        let _oeList = paramsObj.oeList ? paramsObj.oeList.split(",") : []
        setKeyword(_oeList.join('\n'))
        if(paramsObj.oeList) {
          if(_oeList.length > 1) {
            setYcOeList(_oeList)
            setOeAcIndex(0)
            pidList = _oeList
            pidAcIndex = 0
            setSelectArr(_oeList)
            /* let _oeList1 = _oeList.length > 20 ? _oeList.slice(0, 20) : _oeList
            let oeList1 = _oeList1.join(',') */
            // getOeListPart(oeList1, true)
            setPager({
              page: 1,
              size: 60,
              total: 0
            })
            getSearchList(_oeList)
          }else {
            // getOnlyOeList(paramsObj.oeList)
            setSelectArr([])
            setPager({
              page: 1,
              size: 60,
              total: 0
            })
            getSearchList([paramsObj.oeList])
          }
        }else {
          getPidList([], [])
        }
      }
    }
  }, [params, commonStore.userInfo, isGetIsCst, commonStore.pageType])

  useEffect(() => {
    if(pidListParams.oeListArr.length) {
      getPidList(pidListParams.oeListArr, pidListParams.no_find_oe)
    }else if(pidListParams.no_find_oe.length) {
      getDmsList(pidListParams.no_find_oe)
    }
  }, [pidListParams, pager.page, pager.size, partKeyword])

  const initItemWidth = () => {
    if(spacelistRef.current) {
      let clientWidth = spacelistRef.current.clientWidth
      if(clientWidth < 400) {
        setItemWidth('97%')
      }else if(clientWidth >= 400 && clientWidth < 800) {
        setItemWidth('47%')
      }else if(clientWidth >= 800 && clientWidth < 1200) {
        setItemWidth('31%')
      }else if(clientWidth >= 1200 && clientWidth < 1500) {
        setItemWidth('22.5%')
      }else {
        setItemWidth('17.5%')
      }
    }
  }

  /* const _part_list = useMemo(() => {
    setLoading(true)
    if(!selectA) {
      setLoading(false)
      return partList
    } else {
      return partList.filter((it: any) => it.oe === selectA || it.quality_oe === selectA || it.pid === selectA)
    }
  },[partList, selectA]) */

  const priceUnit = useMemo(() => {
    let _unit: string = ''
    if(commonStore.currency_data) {
      if(commonStore.currency_data.unit) {
        _unit = commonStore.currency_data.unit
      }else if(commonStore.currency_data.code) {
        _unit = commonStore.currency_data.code + '  '
      }
    }
    return _unit ? _unit : ''
  }, [commonStore.currency_data])

  const getIsCst = () => {
    accountApi.getIsCst().then((res: any) => {
      if(res.code === 1) {
        setIsCst(res.data.is_cst)
        setIsGetIsCst(true)
        let shop_discount = res.data && res.data.shop_discount ? res.data.shop_discount : 0
        setCommonStore({
          type: 'shop_discount',
          value: shop_discount
        })
      }
    })
  }
  const getCompanyInfo = (userInfo: any) => {
    orderApi.getCompanyInfo({
      repair_shop_id: userInfo && userInfo.repair_shop_id ? userInfo.repair_shop_id : '',
    }).then((res: any) => {
      if(res.code === 1) {
        setCommonStore({
          type: 'companyInfo',
          value: res.data
        })
      }
    })
  }
  const getUserInfo = () => {
    accountApi.getUserInfo().then((res: any) => {
      if(res.code === 1) {
        res.data.company = res.data.reg_company_name
        setCommonStore({value: res.data, type: 'userInfo'})
        getCompanyInfo(res.data)
      }
    })
  }
  const getClassList = () => {
    accountApi.getSecondClass({
      is_hide: 1
    }).then((res: any) => {
      if(res.code === 1) {
        let images_dict = res.data && res.data.images_dict ? res.data.images_dict : {}
        let standard_maingroup = res.data && res.data.standard_maingroup ? res.data.standard_maingroup : []
        setClassImg(images_dict)
        setClassList(standard_maingroup)
        if(Object.keys(res.data.standard_subgroup_name).length) setHasSecondClass(true)
        setGroupClass(res.data.standard_subgroup_name)
      }
    })
  }
  const getFbrandList = () => {
    axios.get("/v1/api/webcst/tag/brand/list").then((res: any) => {
      if(res.code === 1) {
        setFbrandList([...res.data])
      }
    })
  }
  const getHistory = () => {
    vinApi.getHistory({
      page: 1,
      size: 10,
      query_type: 'vin_query,oe_query,en_plate'
    }).then((res: any) => {
      if(res.code === 1) {
        let _data = res.data && res.data.data ? res.data.data : []
        _data.forEach((item: any) => {
          if(item.query_type === 'vin_query') {
            const k = item.keyword.split(',')
            item.vin = k[0]
            item.title = k[1]
            item.carsinfo = k[1]
          }
          if(item.query_type === 'vin') {
            const k = item.keyword.split('\n')
            item.vin = k[0]
            item.title = k[1]
            item.carsinfo = k[1]
          }
        })
        _data = _data.filter((ele: any) => ele.query_type !== 'vin')
        setCommonStore({
          type: 'searchHistory', 
          value: _data
        })
      }
    })
  }
  const getOeHistory = () => {
    vinApi.getHistory({
      query_type: 'oe_query',
      page: 1,
      size: 10
    }).then((res: any) => {
      if(res.code === 1) {
        let _data = res.data && res.data.data ? res.data.data : []
        setOeHistory(_data)
      }
    })
  }
  const getOeListPart = (pid: string, isBegin: boolean, searchOe?: string) => {
    setSelectA("")
    setLoading(true)
    listApi.getOeList({
      oe: pid,
      shop_search: 1
    }).then((res: any) => {
      if(res.code === 1) {
        let _data: any = res.data
        setSelectArr(Object.keys(_data) || [])
        let list: any[] = []
        Object.keys(_data).forEach((items: any) => {
          let type = _data[items].type
          let length = _data[items].data.length
          if(length > 0) {
            let info = _data[items].info
            let brand_list = info.brand_list ? info.brand_list : []
            let brand = brand_list[0] ? brand_list[0] : {}
            let brandCode = brand.brandCode ? brand.brandCode : ''
            _data[items].data.forEach((item: any) => {
              list.push({
                ...item,
                from_oe: items,
                search_oe: searchOe ? searchOe : items,
                brandCode: brandCode,
                is_replace: _data[items].is_replace,
                type: 2 // type=2 零件号正确有库存，详情进入商品详情
              })
            })
          }else {
            if(type === 0) {
              list.push({
                type: type, // type=0  零件号不正确
                pid: items,
                label: items,
                quality_name: '询价',
                from_oe: items,
                search_oe: searchOe ? searchOe : items,
                is_replace: _data[items].is_replace,
              })
            }else {
              let info = _data[items].info
              let dms = _data[items].dms ? _data[items].dms : {}
              let DMS = dms.DMS ? dms.DMS : {}
              let purchase_price = DMS.purchase_price ? parseFloat((DMS.purchase_price / 100).toFixed(2)) : ''
              let brand_list = info.brand_list ? info.brand_list : []
              let brand = brand_list[0] ? brand_list[0] : {}
              list.push({
                type: 1, // type=1  零件号正确无库存，详情进入产品详情
                quality_name: JSON.stringify(DMS) !== '{}' ? '原厂大库' : '原厂',
                pid: info.pid || '',
                label: info.label || '',
                remark: info.remark || '',
                has_replace: info.has_replace || '',
                engpid: info.engpid || '',
                from_oe: items,
                search_oe: searchOe ? searchOe : items,
                isDms: JSON.stringify(DMS) !== '{}' ? true : false,
                quality_price: purchase_price ? purchase_price : 0,
                is_replace: _data[items].is_replace,
                ...brand
              })
            }
          }
        })
        if(isBegin) {
          setPartList(list)
          setDefaultPartList(list)
        }else {
          let _partList = JSON.parse(JSON.stringify(partList))
          setPartList([..._partList, ...list])
          setDefaultPartList([..._partList, ...list])
        }
      }
      setLoading(false)
      if(res.code === 1001) {
        setSupplementOpen(true)
      }
      if(res.code === 1004) {
        Modal.info({
          title: intl.formatMessage({ id: '正在等待所在公司的审核！' }),
          content: intl.formatMessage({ id: '审核通过后可获得更多商品查询次数' }),
          okText: intl.formatMessage({ id: '知道了' }),
          onOk: () => {

          }
        })
      }
    })
  }
  const getOnlyOeList = (value: string) => {
    let goods_cst_ids = commonStore.userInfo && commonStore.userInfo.goods_cst_ids ? commonStore.userInfo.goods_cst_ids : ''
    setLoading(true)
    setSelectA("")
    listApi.searchGroupOeCar({
      keyword: value
    }, {
      merchantidToken: goods_cst_ids
    }).then((res: any) => {
      if(res.code === 1) {
        let oeListArr: any[] = []
        res.data.forEach((ele: any) => {
          let index = oeListArr.findIndex((el: any) => el.goods_id === ele.goods_id)
          if(index === -1) {
            oeListArr.push(ele)
          }
        })
        let oeList = oeListArr.map((item: any) => item.keyword)
        let _oeList = oeList.join(',')
        if(oeList.length > 0) {
          setYcOeList(oeList)
          setOeAcIndex(0)
          pidList = oeList
          pidAcIndex = 0
          let _oeList1 = oeList.length > 20 ? oeList.slice(0, 20) : oeList
          let oeList1 = _oeList1.join(',')
          // getOeListPart(oeList1, true, value)
        }else {
          setYcOeList([value])
          setOeAcIndex(0)
          pidList = [value]
          pidAcIndex = 0
          // getOeListPart(value, true, value)
        }
      }
      if(res.code === 1001) {
        setLoading(false)
        setSupplementOpen(true)
      }
      if(res.code === 1004) {
        setLoading(false)
        Modal.info({
          title: intl.formatMessage({ id: '正在等待所在公司的审核！' }),
          content: intl.formatMessage({ id: '审核通过后可获得更多商品查询次数' }),
          okText: intl.formatMessage({ id: '知道了' }),
          onOk: () => {

          }
        })
      }
    })
  }
  const getSearchList = (value: string[]) => {
    if(!value.length) {
      message.warning(intl.formatMessage({id: '请输入需要查询的零件号或零件编码'}))
      return false
    }
    setSelectA("")
    setLoading(true)
    change_value = value.join(',')
    listApi.searchPartKeyword({
      keyword: value.join(',')
    }).then((res: any) => {
      if(res.code === 1) {
        batch_id = res.data && res.data.batch_id ? res.data.batch_id : ''
        let no_find_oe = res.data && res.data.no_find_oe ? res.data.no_find_oe : []
        let list = res.data && res.data.list ? res.data.list : []
        let oeListArr: any[] = []
        list.forEach((ele: any) => {
          let index = oeListArr.findIndex((el: any) => el.goods_id === ele.goods_id)
          if(index === -1) {
            oeListArr.push(ele)
          }
        })
        let keywordList = oeListArr.map((item: any) => item.keyword)
        setPidListParams({
          oeListArr: oeListArr,
          no_find_oe: no_find_oe
        })
        if(oeListArr.length > 0) {
          // getPidList(oeListArr, no_find_oe)
        }else {
          setYcOeList(value)
          setOeAcIndex(0)
          pidList = value
          pidAcIndex = 0
          if(no_find_oe.length) {
            let oes = no_find_oe.join(',')
            // getDmsList(no_find_oe)
          }else {
            let _list: any[] = []
            value.forEach((item: any) => {
              let isEnVal = /[\u4e00-\u9fa5]/.test(item)
              _list.push({
                type: 0, // type=0  零件号不正确
                pid: isEnVal ? '' : item,
                label: isEnVal ? item : '',
                quality_name: intl.formatMessage({id: '询价'}),
                from_oe: isEnVal ? '' : item,
                search_oe: item,
                is_replace: false,
              })
            })
            setLoading(false)
            setPartList(_list)
            setDefaultPartList(_list)
          }
        } 
        
      }
      if(res.code === 1001) {
        setLoading(false)
        setSupplementOpen(true)
      }
      if(res.code === 1004) {
        setLoading(false)
        Modal.info({
          title: intl.formatMessage({ id: '正在等待所在公司的审核！' }),
          content: intl.formatMessage({ id: '审核通过后可获得更多商品查询次数' }),
          okText: intl.formatMessage({ id: '知道了' }),
          onOk: () => {

          }
        })
      }
    }).catch((err: any) => {
      setLoading(false)
      setPartList([])
    })
  }
  const getPidList = (oeListArr: any[], no_find_oe: string[]) => {
    let oeList = oeListArr.map((item: any) => item.goods_id)
    let _pager = JSON.parse(JSON.stringify(pager))
    /* let _oeList = oeList.join(',')
    setYcOeList(oeList)
    setOeAcIndex(0)
    pidList = oeList
    pidAcIndex = 0
    let _oeList1 = oeList.length > 20 ? oeList.slice(0, 20) : oeList */
    let label_name: string = ''
    if(secondClass || selClass || selTags) {
      let classArr = secondClass ? [secondClass] : (selClass ? [selClass] : [])
      let labelArr = [...classArr]
      if(selTags) {
        let tagsArr = selTags.split(',')
        tagsArr.forEach((ele: any) => {
          let index = labelArr.indexOf(ele)
          if(index === -1) {
            labelArr.push(ele)
          }
        })
      }
      label_name = labelArr.join(',')
      // label_name = `${secondClass ? secondClass : ''}${!secondClass && selClass ? selClass : ''}${(secondClass || selClass) && selTags ? ',' : ''}${selTags ? selTags : ''}`
    }
    listApi.getNewPartList({
      stype: oeListArr.length || no_find_oe.length ? 'oe' : 'category',
      goods_id: oeList.join(','),
      part_name: partKeyword,
      brand: activeFbrand.join(","),
      label_name: secondClass || selClass || selTags,
      position: '',
      brand_names: "",
      no_find_oe: no_find_oe.join(','),
      is_cst: isCst,
      page: pager.page,
      size: pager.size,
      oe_search_info: oeListArr
    }).then((res: any) => {
      if(res.code === 1) {
        let list = res.data.list
        let dms_list = res.data.dms_list
        let total = res.data.total
        _pager.total = total
        setPager(_pager)
        let codeList = list.map((item: any) => {
          return {
            code: item.code,
            brand_names: item.brand_names
          }
        })
        if(codeList.length > 0) {
          listApi.getNewPartListPrice({
            goods_codes: codeList,
            warranty: 1,
            shop_search: 1
          }).then((res1: any) => {
            if(res1.code === 1) {
              let codeData: any = res1.data
              let _list: any[] = []
              list.forEach((item: any) => {
                let goods_id = item.goods_id
                let index = oeListArr.findIndex((ele: any) => goods_id && ele.goods_id === goods_id)
                let search_oe = index > -1 ? oeListArr[index].keyword : ''
                _list.push({
                  type: 2,
                  ...item,
                  quality_oe: item.oe,
                  from_oe: item.oe,
                  search_oe: search_oe,
                  ...codeData[item.code]
                })
              })
              if(dms_list.length) {
                dms_list.forEach((item: any) => {
                  let info = item.info
                  let dms = item.dms ? item.dms : {}
                  let DMS = dms.DMS ? dms.DMS : {}
                  let ext = dms.extra ? dms.extra : {}
                  let purchase_price = DMS.purchase_price ? parseFloat((DMS.purchase_price / 100).toFixed(2)) : ''
                  let brand_list = info.brand_list ? info.brand_list : []
                  let brand = brand_list[0] ? brand_list[0] : {}
                  if(item.type === 1) {
                    let stockData = [
                      {
                        key: intl.formatMessage({ id: "更新时间" }),
                        val: DMS.update_date || ''
                      },
                      {
                        key: intl.formatMessage({ id: "进货价(含税)" }),
                        val: DMS['purchase_price'] ? `￥${DMS['purchase_price'] / 100}` : ''
                      },
                      {
                        key: intl.formatMessage({ id: "销售价(含税)" }),
                        val: DMS['price'] ? `￥${DMS['price'] / 100}` : ''
                      },
                      {
                        key: intl.formatMessage({ id: "库存数量" }),
                        val: ext.number || ''
                      },
                      {
                        key: intl.formatMessage({ id: "长" }),
                        val: ext['length'] ? `${ext['length'].toFixed(2)}${intl.formatMessage({ id: '米' })}` : ''
                      },
                      {
                        key: intl.formatMessage({ id: "宽" }),
                        val: ext['width'] ? `${ext['width'].toFixed(2)}${intl.formatMessage({ id: '米' })}` : ''
                      },
                      {
                        key: intl.formatMessage({ id: "高" }),
                        val: ext['height'] ? `${ext['height'].toFixed(2)}${intl.formatMessage({ id: '米' })}` : ''
                      },
                      {
                        key: intl.formatMessage({ id: "重" }),
                        val: ext['weight'] ? `${ext['weight'].toFixed(2)}kg` : ''
                      },
                      {
                        key: intl.formatMessage({ id: "净重" }),
                        val: ext['weight_net'] ? `${ext['weight_net'].toFixed(2)}kg` : ''
                      },
                      {
                        key: intl.formatMessage({ id: "危险品" }),
                        val: ext.hazardous ? intl.formatMessage({ id: "危险品" }) : intl.formatMessage({ id: "非危险品" })
                      },
                      {
                        key: intl.formatMessage({ id: "易碎品" }),
                        val: ext.fragile ? intl.formatMessage({ id: "易碎品" }) : intl.formatMessage({ id: "非易碎品" })
                      },
                      {
                        key: intl.formatMessage({ id: "税点" }),
                        val: ext['tax'] ? `${ext['tax'] * 100}%` : ''
                      },
                      {
                        key: intl.formatMessage({ id: "税额" }),
                        val: ext['tax_price'] ? `￥${ext['tax_price'] / 100}` : ''
                      },
                      {
                        key: intl.formatMessage({ id: "备注信息" }),
                        val: ext.description || ''
                      }
                    ]
                    _list.push({
                      type: 1, // type=1  零件号正确无库存，详情进入产品详情
                      quality_name: JSON.stringify(DMS) !== '{}' ? intl.formatMessage({id: '原厂大库'}) : intl.formatMessage({id: '原厂'}),
                      pid: info.pid || '',
                      label: info.label || '',
                      remark: info.remark || '',
                      has_replace: info.has_replace || '',
                      engpid: info.engpid || '',
                      from_oe: info.pid,
                      search_oe: item.oe,
                      isDms: JSON.stringify(DMS) !== '{}' ? true : false,
                      quality_price: purchase_price ? purchase_price : 0,
                      is_replace: item.is_replace,
                      ...brand,
                      supportBuy: {
                        ...dms,
                        stockData
                      }
                    })
                  }else if(item.type === 0) {
                    let info = item.info ? item.info : {}
                    let brand_list = info.brand_list ? info.brand_list : []
                    let brand = brand_list[0] ? brand_list[0] : {}
                    if(info.pid) {
                      _list.push({
                        type: 0, // type=0  零件号不正确
                        pid: info.pid || '',
                        label: info.label || '',
                        remark: info.remark || '',
                        quality_name: intl.formatMessage({id: '询价'}),
                        from_oe: item.oe,
                        search_oe: item.oe,
                        is_replace: false,
                      })
                    }else {
                      _list.push({
                        type: 0, // type=0  零件号不正确
                        pid: item.oe,
                        label: item.label ? item.label : item.oe,
                        quality_name: intl.formatMessage({id: '询价'}),
                        from_oe: item.oe,
                        search_oe: item.oe,
                        is_replace: false,
                      })
                    }
                  }
                  
                })
              }
              setPartList(_list)
              setDefaultPartList(_list)
            }
            setLoading(false)
          }).catch((err: any) => {
            setLoading(false)
          })
        }else {
          let _list: any[] = []
          if(dms_list.length) {
            dms_list.forEach((item: any) => {
              let info = item.info
              let dms = item.dms ? item.dms : {}
              let DMS = dms.DMS ? dms.DMS : {}
              let ext = dms.extra ? dms.extra : {}
              let purchase_price = DMS.purchase_price ? parseFloat((DMS.purchase_price / 100).toFixed(2)) : ''
              let brand_list = info.brand_list ? info.brand_list : []
              let brand = brand_list[0] ? brand_list[0] : {}
              if(item.type === 1) {
                let stockData = [
                  {
                    key: intl.formatMessage({ id: "更新时间" }),
                    val: DMS.update_date || ''
                  },
                  {
                    key: intl.formatMessage({ id: "进货价(含税)" }),
                    val: DMS['purchase_price'] ? `￥${DMS['purchase_price'] / 100}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "销售价(含税)" }),
                    val: DMS['price'] ? `￥${DMS['price'] / 100}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "库存数量" }),
                    val: ext.number || ''
                  },
                  {
                    key: intl.formatMessage({ id: "长" }),
                    val: ext['length'] ? `${ext['length'].toFixed(2)}${intl.formatMessage({ id: '米' })}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "宽" }),
                    val: ext['width'] ? `${ext['width'].toFixed(2)}${intl.formatMessage({ id: '米' })}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "高" }),
                    val: ext['height'] ? `${ext['height'].toFixed(2)}${intl.formatMessage({ id: '米' })}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "重" }),
                    val: ext['weight'] ? `${ext['weight'].toFixed(2)}kg` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "净重" }),
                    val: ext['weight_net'] ? `${ext['weight_net'].toFixed(2)}kg` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "危险品" }),
                    val: ext.hazardous ? intl.formatMessage({ id: "危险品" }) : intl.formatMessage({ id: "非危险品" })
                  },
                  {
                    key: intl.formatMessage({ id: "易碎品" }),
                    val: ext.fragile ? intl.formatMessage({ id: "易碎品" }) : intl.formatMessage({ id: "非易碎品" })
                  },
                  {
                    key: intl.formatMessage({ id: "税点" }),
                    val: ext['tax'] ? `${ext['tax'] * 100}%` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "税额" }),
                    val: ext['tax_price'] ? `￥${ext['tax_price'] / 100}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "备注信息" }),
                    val: ext.description || ''
                  }
                ]
                _list.push({
                  type: 1, // type=1  零件号正确无库存，详情进入产品详情
                  quality_name: JSON.stringify(DMS) !== '{}' ? intl.formatMessage({id: '原厂大库'}) : intl.formatMessage({id: '原厂'}),
                  pid: info.pid || '',
                  label: info.label || '',
                  remark: info.remark || '',
                  has_replace: info.has_replace || '',
                  engpid: info.engpid || '',
                  from_oe: info.pid,
                  search_oe: item.oe,
                  isDms: JSON.stringify(DMS) !== '{}' ? true : false,
                  quality_price: purchase_price ? purchase_price : 0,
                  is_replace: item.is_replace,
                  ...brand,
                  supportBuy: {
                    ...dms,
                    stockData
                  }
                })
              }else if(item.type === 0) {
                let info = item.info ? item.info : {}
                let brand_list = info.brand_list ? info.brand_list : []
                let brand = brand_list[0] ? brand_list[0] : {}
                if(info.pid) {
                  _list.push({
                    type: 0, // type=0  零件号不正确
                    pid: info.pid || '',
                    label: info.label || '',
                    remark: info.remark || '',
                    quality_name: intl.formatMessage({id: '询价'}),
                    from_oe: item.oe,
                    search_oe: item.oe,
                    is_replace: false,
                  })
                }else {
                  _list.push({
                    type: 0, // type=0  零件号不正确
                    pid: item.oe,
                    label: item.label ? item.label : item.oe,
                    quality_name: intl.formatMessage({id: '询价'}),
                    from_oe: item.oe,
                    search_oe: item.oe,
                    is_replace: false,
                  })
                }
                
              }
            })
          }
          setLoading(false)
          setPartList(_list)
          setDefaultPartList(_list)
        }
      }else {
        setLoading(false)
        setPartList([])
        setDefaultPartList([])
      }
    }).catch((err: any) => {
      setLoading(false)
      setPartList([])
      setDefaultPartList([])
    })
  }
  const getDmsList = (oes: string[]) => {
    let _pager = JSON.parse(JSON.stringify(pager))
    let label_name: string = ''
    if(secondClass || selClass || selTags) {
      let classArr = secondClass ? [secondClass] : (selClass ? [selClass] : [])
      let labelArr = [...classArr]
      if(selTags) {
        let tagsArr = selTags.split(',')
        tagsArr.forEach((ele: any) => {
          let index = labelArr.indexOf(ele)
          if(index === -1) {
            labelArr.push(ele)
          }
        })
      }
      label_name = labelArr.join(',')
      // label_name = `${secondClass ? secondClass : ''}${!secondClass && selClass ? selClass : ''}${(secondClass || selClass) && selTags ? ',' : ''}${selTags ? selTags : ''}`
    }
    listApi.getDmsList({
      oes: oes.join(','),
      brand: activeFbrand.join(","),
      label_name: secondClass || selClass || selTags,
      part_name: partKeyword,
      page: pager.page,
      size: pager.size
    }).then((res: any) => {
      if(res.code === 1) {
        let total = res.data && res.data.total ? res.data.total : 0
        _pager.total = total
        setPager(_pager)
        let dms_list = res.data && res.data.list ? res.data.list : []
        let _list: any[] = []
          if(dms_list.length) {
            dms_list.forEach((item: any) => {
              let info = item.info
              let dms = item.dms ? item.dms : {}
              let DMS = dms.DMS ? dms.DMS : {}
              let ext = dms.extra ? dms.extra : {}
              let purchase_price = DMS.purchase_price ? parseFloat((DMS.purchase_price / 100).toFixed(2)) : ''
              let brand_list = info.brand_list ? info.brand_list : []
              let brand = brand_list[0] ? brand_list[0] : {}
              if(item.type === 1) {
                let stockData = [
                  {
                    key: intl.formatMessage({ id: "更新时间" }),
                    val: DMS.update_date || ''
                  },
                  {
                    key: intl.formatMessage({ id: "进货价(含税)" }),
                    val: DMS['purchase_price'] ? `￥${DMS['purchase_price'] / 100}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "销售价(含税)" }),
                    val: DMS['price'] ? `￥${DMS['price'] / 100}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "库存数量" }),
                    val: ext.number || ''
                  },
                  {
                    key: intl.formatMessage({ id: "长" }),
                    val: ext['length'] ? `${ext['length'].toFixed(2)}${intl.formatMessage({ id: '米' })}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "宽" }),
                    val: ext['width'] ? `${ext['width'].toFixed(2)}${intl.formatMessage({ id: '米' })}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "高" }),
                    val: ext['height'] ? `${ext['height'].toFixed(2)}${intl.formatMessage({ id: '米' })}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "重" }),
                    val: ext['weight'] ? `${ext['weight'].toFixed(2)}kg` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "净重" }),
                    val: ext['weight_net'] ? `${ext['weight_net'].toFixed(2)}kg` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "危险品" }),
                    val: ext.hazardous ? intl.formatMessage({ id: "危险品" }) : intl.formatMessage({ id: "非危险品" })
                  },
                  {
                    key: intl.formatMessage({ id: "易碎品" }),
                    val: ext.fragile ? intl.formatMessage({ id: "易碎品" }) : intl.formatMessage({ id: "非易碎品" })
                  },
                  {
                    key: intl.formatMessage({ id: "税点" }),
                    val: ext['tax'] ? `${ext['tax'] * 100}%` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "税额" }),
                    val: ext['tax_price'] ? `￥${ext['tax_price'] / 100}` : ''
                  },
                  {
                    key: intl.formatMessage({ id: "备注信息" }),
                    val: ext.description || ''
                  }
                ]
                _list.push({
                  type: 1, // type=1  零件号正确无库存，详情进入产品详情
                  quality_name: JSON.stringify(DMS) !== '{}' ? intl.formatMessage({id: '原厂大库'}) : intl.formatMessage({id: '原厂'}),
                  pid: info.pid || '',
                  label: info.label || '',
                  remark: info.remark || '',
                  has_replace: info.has_replace || '',
                  engpid: info.engpid || '',
                  from_oe: info.pid,
                  search_oe: item.oe,
                  isDms: JSON.stringify(DMS) !== '{}' ? true : false,
                  quality_price: purchase_price ? purchase_price : 0,
                  is_replace: item.is_replace,
                  ...brand,
                  supportBuy: {
                    ...dms,
                    stockData
                  }
                })
              }else if(item.type === 0) {
                let info = item.info ? item.info : {}
                let brand_list = info.brand_list ? info.brand_list : []
                let brand = brand_list[0] ? brand_list[0] : {}
                if(info.pid) {
                  _list.push({
                    type: 0, // type=0  零件号不正确
                    pid: info.pid || '',
                    label: info.label || '',
                    remark: info.remark || '',
                    quality_name: intl.formatMessage({id: '询价'}),
                    from_oe: item.oe,
                    search_oe: item.oe,
                    is_replace: false,
                  })
                }else {
                  _list.push({
                    type: 0, // type=0  零件号不正确
                    pid: item.oe,
                    label: item.label ? item.label : item.oe,
                    quality_name: intl.formatMessage({id: '询价'}),
                    from_oe: item.oe,
                    search_oe: item.oe,
                    is_replace: false,
                  })
                }
              }
              
            })
          }
          setPartList(_list)
          setDefaultPartList(_list)
      }
      setLoading(false)
    })
  }
  const inputChange = (e: any) => {
    let value = e.target.value
    // value = value.replace(/[^0-9a-zA-Z.\n]/g, '').toUpperCase()
    setKeyword(value) 
  }
  const searchOeInput = (value: string) => {
    old_value = change_value
    let val = value.replace(/\n(\n)+/g, '\n').replace(/\n$/, '').replace(/^\n/, '')
    if(val === ''){
      getPidList([], [])
      return false
    }
    let isEnVal = /[\u4e00-\u9fa5]/.test(val)
    if(!isEnVal && val.length < 5) {
      message.warning("至少输入5位字符")
      return false
    }
    if(isEnVal && val.length < 2) {
      message.warning("至少输入2位字符")
      return false
    }
    let _oeList = val.split(/\n/).join(',')
    let _class = selClass + `${secondClass ? ',' + secondClass : ''}`
    let _class2 = _class.replace(/\&/, "+")
    let _searchParams = strEncrypt({
      oeList: _oeList,
      class: _class2,
      tags: _class2 ? '' : selTags,
      partKeyword: val.split(/\n/) && val.split(/\n/)[0] ? val.split(/\n/)[0] : ''
    })
    setSearchParams({
      params: _searchParams
    })
    vinApi.setHistory({
      brandCode: '',
      keyword: _oeList,
      query_type: 'oe_query'
    }).then((res2: any) => {
      if(res2.code === 1) {
        if(pageType === '5' || pageType === '6') {
          getHistory()
        }else {
          getOeHistory()
        }
      }
    })
    if(val.split(/\n/).length && val.split(/\n/).length > 1) {
      let arr = val.split(/\n/)
      let _oeList1 = arr.length > 20 ? arr.slice(0, 20) : arr
      let oeList1 = _oeList1.join(',')
      setYcOeList(arr)
      setOeAcIndex(0)
      pidList = val.split(/\n/)
      pidAcIndex = 0
      // getOeListPart(oeList1, true)
      setSelectArr(arr)
      setPager({
        page: 1,
        size: 60,
        total: 0
      })
      getSearchList(arr)
    }else {
      // getOnlyOeList(val)
      if(val.split(/\n/).length) {
        setSelectArr([])
        setPager({
          page: 1,
          size: 60,
          total: 0
        })
        getSearchList([val])
      }
    }
  }
  const toPartHistory = () => {
    navigate('/partHistoryList')
  }
  const oeItemClick = (item: any) => {
    old_value = change_value
    let _keyword = item.keyword
    let _oeList = _keyword.split(",")
    setKeyword(_oeList.join('\n'))
    let _class = selClass + `${secondClass ? ',' + secondClass : ''}`
    let _class2 = _class.replace(/\&/, "+")
    let _searchParams = strEncrypt({
      oeList: _oeList.join(','),
      class: _class2,
      tags: _class2 ? '' : selTags,
      partKeyword: _oeList && _oeList[0] ? _oeList[0] : ''
    })
    setSearchParams({
      params: _searchParams
    })
    if(_oeList.length > 1) {
      setYcOeList(_oeList)
      setOeAcIndex(0)
      pidList = _oeList
      pidAcIndex = 0
      let _oeList1 = _oeList.length > 20 ? _oeList.slice(0, 20) : _oeList
      let oeList1 = _oeList1.join(',')
      // getOeListPart(oeList1, true)
      setSelectArr(_oeList)
      setPager({
        page: 1,
        size: 60,
        total: 0
      })
      getSearchList(_oeList)
    }else {
      // getOnlyOeList(_keyword)
      setSelectArr([])
      setPager({
        page: 1,
        size: 60,
        total: 0
      })
      getSearchList([_keyword])
    }
    
  }
  const toHistoryMore = () => {
    navigate('/partHistoryList')
  }
  const selClassChange = (key: string) => {
    setSelTags('')
    setSelClass(key)
    setSecondClass("")
    let _pager = JSON.parse(JSON.stringify(pager))
    _pager.page = 1
    setPager(_pager)
    let _key = key ? key.replace(/\&/, "+") : ''
    console.log("selClassChange keyword:", keyword)
    let val = keyword.replace(/\n(\n)+/g, '\n').replace(/\n$/, '').replace(/^\n/, '')
    let _oeList = val.split(/\n/)
    let classParams = {
      class: _key,
      oeList: _oeList.join(','),
      tags: _key ? '' : selTags,
      partKeyword: _oeList && _oeList[0] ? _oeList[0] : ''
    }
    if(val) {
      old_value = change_value
      let _searchParams = strEncrypt(classParams)
      setSearchParams({
        params: _searchParams
      })
      // getSearchList(_oeList)
    }else {
      // message.warning(intl.formatMessage({id: '请输入需要查询的零件号或零件编码'}))
      setPidListParams({
        oeListArr: [],
        no_find_oe: []
      })
      let classParams = {
        class: _key,
        oeList: val ? val : '',
        tags: _key ? '' : selTags,
        partKeyword: _oeList && _oeList[0] ? _oeList[0] : ''
      }
      let _searchParams = strEncrypt(classParams)
      setSearchParams({
        params: _searchParams
      })
      // getPidList([], [])
    }
    
  }
  // const capitalizeFirstLetter = (string: string) => {
  //   if(localStorage.getItem('lang') === 'en' && string) {
  //     return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  //   }
  //   return string
  // }
  const capitalizeFirstLetter = (string: string) => {
    if(localStorage.getItem('lang') === 'en' && string) {
      return string.split(' ').map((word: string) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
    }else {
      return string
    }
  }
  const secondClassChange = (key: string) => {
    setSelTags('')
    setSecondClass(key)
    let _pager = JSON.parse(JSON.stringify(pager))
    _pager.page = 1
    setPager(_pager)
    let _class = selClass + `${key ? ',' + key : ''}`
    let _class2 = _class.replace(/\&/, "+")
    let val = keyword.replace(/\n(\n)+/g, '\n').replace(/\n$/, '').replace(/^\n/, '')
    let _oeList = val.split(/\n/)
    let classParams = {
      class: _class2,
      oeList: _oeList.join(','),
      tags: _class2 ? '' : selTags,
      partKeyword: _oeList && _oeList[0] ? _oeList[0] : ''
    }
    if(val) {
      old_value = change_value
      let _searchParams = strEncrypt(classParams)
      setSearchParams({
        params: _searchParams
      })
      // getSearchList(_oeList)
    }else {
      let classParams = {
        class: _class2,
        oeList: val ? val : '',
        tags: _class2 ? '' : selTags,
        partKeyword: _oeList && _oeList[0] ? _oeList[0] : ''
      }
      let _searchParams = strEncrypt(classParams)
      setSearchParams({
        params: _searchParams
      })
      // getPidList([], [])
      // message.warning(intl.formatMessage({id: '请输入需要查询的零件号或零件编码'}))
    }
  }
  const handleFbrand = (item: any) => {
    setPager({
      page: 1,
      size: 60,
      total: 0
    })
    if(item.name) {
      setActiveFbrand([item.name])
    }else {
      setActiveFbrand([])
    }
  }
  const sortTypeChange = (e: RadioChangeEvent) => {
    let value = e.target.value
    setSortType(value)
    if(value === 'default') {
      setPartList(defaultPartList)
    }else if(value === 'highToLow') {
      let _dataList = partList.sort((a: any, b: any) => {
        return b.quality_price - a.quality_price
      })
      setPartList(_dataList)
    }else if(value === 'lowToHigh') {
      let _dataList = partList.sort((a: any, b: any) => {
        return a.quality_price - b.quality_price
      })
      setPartList(_dataList)
    }
  }
  const toPartDtl = (item: any) => {
    if(item.type === 1 || item.type === 0) {
      return false
    }
    if((commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
      message.warning(intl.formatMessage({ id: "暂无权限" }))
      return false
    }
    let _brandCode = item.oe_image_info && item.oe_image_info.brandCode ? item.oe_image_info.brandCode : (item.brandCode ? item.brandCode : '')
    let oe = item.quality_oe ? item.quality_oe.replace(/\s+/g, '') : (item.pid ? item.pid : '')
    if(isCst) {
      let id = item.parts_id ? item.parts_id : item.id
      if(!id) {
        id = item.goods_id
      }
      if(open_new === '2') {
				navigate(`/partDtl?goods_id=${id}&params=${params}&type=oe&brand_code=${_brandCode}&goods_cst_id=${item.goods_cst_id}`)
			}else {
				window.open(`/partDtl?goods_id=${id}&params=${params}&type=oe&brand_code=${_brandCode}&goods_cst_id=${item.goods_cst_id}`, "" + JsGuid())
			}
    }else {
      if(item.code) {
        if(open_new === '2') {
          try {
            clear()
          }catch(err: any) {
            
          }
          navigate(`/oe/pidDtl?goods_code=${item.code ? item.code : ''}&type=pid&brandCode=${_brandCode}&pid=${oe}`)
        }else {
          window.open(`/oe/pidDtl?goods_code=${item.code ? item.code : ''}&type=pid&brandCode=${_brandCode}&pid=${oe}`, "" + JsGuid())
        }
      }else {
        if(open_new === '2') {
          try {
            clear()
          }catch(err: any) {
            
          }
          navigate(`/oe/pidDtl?goods_code=${item.code ? item.code : ''}&type=no_pid&brandCode=${_brandCode}&pid=${oe}`)
        }else {
          window.open(`/oe/pidDtl?goods_code=${item.code ? item.code : ''}&type=no_pid&brandCode=${_brandCode}&pid=${oe}`, "" + JsGuid())
        }
      }
      
    }
    
  } 
  const toPartDetail = (item: any) => {
    if(item.type === 1 || item.type === 0) {
      return false
    }
    if((commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
      message.warning(intl.formatMessage({ id: "暂无权限" }))
      return false
    }
    let _brandCode = item.oe_image_info && item.oe_image_info.brandCode ? item.oe_image_info.brandCode : (item.brandCode ? item.brandCode : '')
    let pid = item.pid.replace(/\s+/g, '')
    if(open_new === '2') {
      navigate(`/oe/part?pid=${pid}&brandcode=${_brandCode}`)
    }else {
      window.open(`/oe/part?pid=${pid}&brandcode=${_brandCode}`, "" + JsGuid())
    }
    
  }
  const toPidDtl = (item: any) => {
    if(item.type === 1 || item.type === 0) {
      return false
    }
    if((commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
      message.warning(intl.formatMessage({ id: "暂无权限" }))
      return false
    }
    let pid = item.pid.replace(/\s+/g, '')
    if(open_new === '2') {
      try {
        clear()
      }catch(err: any) {
        
      }
      navigate(`/oe/pidDtl?pid=${pid}&type=no_pid`)
    }else {
      window.open(`/oe/pidDtl?pid=${pid}&type=no_pid`, "" + JsGuid())
    }
    
    
  }
  const pagerChange = (page: number, pageSize: number) => {
    let _pager = JSON.parse(JSON.stringify(pager))
    _pager.page = page
    _pager.size = pageSize
    setPager(_pager)
    
  }
  const applyViewPrice = (e: any, items: any) => {
    e.stopPropagation()
    if(commonStore.userInfo && !commonStore.companyInfo.validate_status) {
      message.warning(intl.formatMessage({id: '认证正在审核中，请您耐心等候。如需加急，可联系管理员处理。'}))
    }else if(commonStore.userInfo && commonStore.companyInfo.validate_status && (commonStore.companyInfo.validate_status === 2 || commonStore.companyInfo.validate_status === 3)) {
      setSupplementOpen(true)
    }else {
      applyPriceTemplate()
    }
  }
  const applyPriceTemplate = () => {
    accountApi.applyPriceTemplate({}).then((res: any) => {
      if(res.code === 1) {
        message.warning(intl.formatMessage({id: '价格申请已提交管理员审核，请您耐心等候。如需加急，可联系管理员处理。'}))
      }
    })
  }
  const openAsstModal = (e: any, info: any) => {
    e.stopPropagation()
    setAsstInfo(info)
    setAsstShow(true)
  }
  const addCart = (e: any, items: any) => {
    e.stopPropagation()
    if(localStorage.getItem("token") && (!localStorage.getItem('tourist_user'))) {
      let _brandCode = items.oe_image_info && items.oe_image_info.brandCode ? items.oe_image_info.brandCode : (items.brandCode ? items.brandCode : '')
      if(items.type === 2) {
        if(isCst) {
          let hash_msg = 'oe&' + items.code
          let hash_value = hex_md5(hash_msg)
          let paramsObj: any = params ? getDecryptParams(params) : {}
          let param: any = {
            query_type: 'oe',
            query_info: {
              code: items.code,
              goods_id: items.goods_id,
              brandcode: _brandCode
            },
            goods_info: {
              goods_code: items.code,
              num: 1,
              goods_cst_id: items.goods_cst_id,
              stock_type: 'erp',
              fromDtl: 'goods', // part 产品详情  goods商品详情  pid零件号详情
              data: {
                code: items.code,
                goods_id: items.goods_id, 
                brandcode: _brandCode
              },
            },
            hash_value: hash_value
          }
          orderApi.addCart(param).then((res: any) => {
            if(res.code === 1) {
              message.success(intl.formatMessage({ id: '已添加至购物车' }))
              setCommonStore({
                type: 'cartNum',
                value: commonStore.cartNum ? commonStore.cartNum + 1 : 1
              })
              getCartList()
            }
          })
        }else {
          let vin = ""
          let goods_code = items.code
          let pid = items.from_oe.replace(/\s+/g, '')
          let hash_value = vin ? hex_md5('goods' + vin) : hex_md5('goods' + pid)
          listApi.getOeBrand({
            oe: items.quality_oe
          }).then((res: any) => {
            if(res.code === 1) {
              let info = res.data && res.data.info ? res.data.info : {}
              let brand_list = info.brand_list ? info.brand_list : []
              let brand = brand_list[0] ? brand_list[0] : {}
              let brandCode = brand.brandCode ? brand.brandCode : ''
              let oe = items.quality_oe.replace(/\s+/g, '')
              let _brandCode = items.oe_image_info && items.oe_image_info.brandCode ? items.oe_image_info.brandCode : (items.brandCode ? items.brandCode : '')
              if(pid) {
                let param: any = {
                  query_type: vin ? 'vin' : 'oe',
                  query_info: {
                    code: items.code,
                    oe: pid,
                    // brandcode: item.brandCode,
                    vin_img: "",
                    brandcode: _brandCode,
                  },
                  goods_info: {
                    goods_code: items.code,
                    num: 1,
                    goods_cst_id: items.goods_cst_id ? items.goods_cst_id : '',
                    stock_type: 'erp',
                    fromDtl: 'pid', // part 产品详情  goods商品详情  pid零件号详情
                    goods_id: items.goods_id,
                    data: {
                      title: vin ? vin : pid,
                      detail: {},
                      code: items.code,
                      oe: pid,
                      // brandcode: item.brandCode
                      brandcode: _brandCode
                    }
                  },
                  hash_value: hash_value
                }
                if(vin) {
                  param.query_info.vin = vin
                }
                orderApi.addCart(param).then((res: any) => {
                  if(res.code === 1) {
                    message.success(intl.formatMessage({ id: '已添加至购物车' }))
                    setCommonStore({
                      type: 'cartNum',
                      value: commonStore.cartNum ? commonStore.cartNum + 1 : 1
                    })
                    getCartList()
                  }
                })
              }
            }
          })
        }
      }else if(items.type === 0) {
        let vin = ""
        let part_name = items.part_name
        let pid = items.from_oe.replace(/\s+/g, '')
        let hash_msg = vin ? ('yc&' + vin) : (pid ? ('yc&' + pid) : ('yc&' + part_name))
        let hash_value = hex_md5(hash_msg)
        let _vin = vin ? vin : ''
        let _part_name = part_name ? part_name : ''
        let param: any = {
          query_type: vin ? 'vin' : 'oe',
          query_info: {
            oe: pid,
            vin_img: "",
            brandcode: _brandCode,
          },
          goods_info: {
            goods_code: pid ? pid : (_vin + _part_name),
            num: 1,
            stock_type: 'yc',
            fromDtl: 'pid', // part 产品详情  goods商品详情  pid零件号详情
            data: {
              detail: {},
              title: vin ? vin : pid,
              // brandcode: '',
              brandcode: _brandCode,
              part_name: part_name ? part_name : pid,
              oe: pid,
              amount: 1,
              price_4s: '',
              unit: '',
              break_img: '',
              standard_label: '',
              pid_replacement: [],
              img_point: {},
              img: '',
            }
          },
          hash_value: hash_value
        }
        if(vin) {
          param.query_info.vin = vin
        }
        orderApi.addCart(param).then((res: any) => {
          if(res.code === 1) {
            message.success(intl.formatMessage({ id: '已添加至购物车' }))
            setCommonStore({
              type: 'cartNum',
              value: commonStore.cartNum + 1
            })
            getCartList()
          }
        })
      }else if(items.type === 1) {
        let param: any = {}
        if(items.isDms) {
          if(items.supportBuy.DMS && !items.supportBuy.DMS.firm_code){
            let type = 'yc'
            let pid = items.from_oe.replace(/\s+/g, '')
            let hash_value = hex_md5('goods' + pid)
            let pic: any = []
            let imagesList = items.images && items.images.split(',') && items.images.split(',').length ? items.images.split(',') : []
            if(imagesList.length){
              imagesList.forEach((img: string)=>{
                pic.push({
                  pic: `${img}`
                })
              })
            }
            let supportBasic = {
              pic,
              label: items.label,
              info: [
                {
                  key: intl.formatMessage({ id: "原厂OE号" }),
                  value: items.pid
                },
                {
                  key: intl.formatMessage({ id: "零件名称" }),
                  value: items.label
                }
              ]
            }
            param = {
              query_type: 'oe',
              query_info: {
                brandcode: _brandCode,
                oe: pid,
                vin: '',
                mcid: '',
              },
              goods_info: {
                goods_code: pid || '',
                num: 1,
                stock_type: 'yc',
                fromDtl: 'part', // part 产品详情  goods商品详情  pid零件号详情
                data: {
                  detail: {},
                  title: pid,
                  brandcode: _brandCode,
                  part_name: supportBasic.label,
                  oe: pid,
                  amount: 1,
                  price_4s: '',
                  unit: '',
                  break_img: '',
                  standard_label: '',
                  pid_replacement: [],
                  img_point: {},
                  img: supportBasic.pic.length ? supportBasic.pic[0].pic : ''
                }
              },
              hash_value: hash_value
            }
          }else {
            let type = 'epc'
            let pid = items.from_oe.replace(/\s+/g, '')
            let pic: any = []
            let imagesList = items.images && items.images.split(',') && items.images.split(',').length ? items.images.split(',') : []
            if(imagesList.length){
              imagesList.forEach((img: string)=>{
                pic.push({
                  pic: `${img}`
                })
              })
            }
            let supportBasic = {
              pic,
              label: items.label,
              info: [
                {
                  key: intl.formatMessage({ id: "原厂OE号" }),
                  value: items.pid
                },
                {
                  key: intl.formatMessage({ id: "零件名称" }),
                  value: items.label
                }
              ]
            }
            let hash_value = hex_md5('goods' + pid)
            param = {
              query_type: 'oe',
              query_info: {
                oe: pid,
                brandcode: _brandCode,
                mcid: '',
              },
              goods_info: {
                goods_code: pid,
                num: 1,
                stock_type: 'epc',
                fromDtl: 'part', // part 产品详情  goods商品详情  pid零件号详情
                data: {
                  oe: pid,
                  brandcode: _brandCode,
                  basic: supportBasic,
                  title: pid,
                  supportBuy: items.supportBuy,
                  detail: {}
                }
              },
              hash_value: hash_value
            }
          }
          
        }else {
          let type = 'yc'
          let pid = items.from_oe.replace(/\s+/g, '')
          let hash_value = hex_md5('goods' + pid)
          let pic: any = []
          let imagesList = items.images && items.images.split(',') && items.images.split(',').length ? items.images.split(',') : []
          if(imagesList.length){
            imagesList.forEach((img: string)=>{
              pic.push({
                pic: `${img}`
              })
            })
          }
          let supportBasic = {
            pic,
            label: items.label,
            info: [
              {
                key: intl.formatMessage({ id: "原厂OE号" }),
                value: items.pid
              },
              {
                key: intl.formatMessage({ id: "零件名称" }),
                value: items.label
              }
            ]
          }
          param = {
            query_type: 'oe',
            query_info: {
              brandcode: _brandCode,
              oe: pid,
              vin: '',
              mcid: '',
            },
            goods_info: {
              goods_code: pid || '',
              num: 1,
              stock_type: 'yc',
              fromDtl: 'part', // part 产品详情  goods商品详情  pid零件号详情
              data: {
                detail: {},
                title: pid,
                brandcode: _brandCode,
                part_name: supportBasic.label,
                oe: pid,
                amount: 1,
                price_4s: '',
                unit: '',
                break_img: '',
                standard_label: '',
                pid_replacement: [],
                img_point: {},
                img: supportBasic.pic.length ? supportBasic.pic[0].pic : ''
              }
            },
            hash_value: hash_value
          }
        }
        orderApi.addCart(param).then((res: any) => {
          if(res.code === 1) {
            message.success(intl.formatMessage({ id: '已添加至购物车' }))
            setCommonStore({
              type: 'cartNum',
              value: commonStore.cartNum + 1
            })
            getCartList()
          }
        })
      }
    }else {
      navigate('/login')
    }
    
  }
  const getCartList = () => {
    orderApi.getCartList().then((res: any) => {
      if(res.code === 1) {
        let _data = res.data
        let length = 0
        let price = 0
        let goods_code_list: any = []
        Object.keys(_data).forEach((items: string) => {
          Object.keys(_data[items].goods_list).forEach((item: string) => {
            length += 1
            _data[items].goods_list[item].selected = true
            if(_data[items].goods_list[item].stock_type === 'epc'){
              const d = _data[items].goods_list[item].data
              const basic = d.basic
              const supportBuy = d.supportBuy
              if(basic && supportBuy){
                if(basic.pic && basic.pic.length){
                  _data[items].goods_list[item].images = basic.pic[0].pic
                }else {
                  _data[items].goods_list[item].images = d.detail.img || ''
                }
                _data[items].goods_list[item].part_name = basic.label
                _data[items].goods_list[item].quality_name = intl.formatMessage({id: '大库原厂'})
                _data[items].goods_list[item].quality_oe = supportBuy.pid
                if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
                  _data[items].goods_list[item]['4s_price'] = supportBuy.DMS.price / 100
                }
                _data[items].goods_list[item].quality_price = supportBuy.DMS.purchase_price / 100
                if(supportBuy.DMS.purchase_price) {
                  price += _data[items].goods_list[item].quality_price * _data[items].goods_list[item].num
                }
                
              }
            }else if(_data[items].goods_list[item].stock_type === 'yc'){
              const info = _data[items].goods_list[item].data
              _data[items].goods_list[item].images = info.img || info.detail.img || ''
              _data[items].goods_list[item].part_name = info.part_name
              _data[items].goods_list[item].quality_name = intl.formatMessage({id: '原厂'})
              _data[items].goods_list[item].quality_oe = info.oe
              if(commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'CNY') {
                _data[items].goods_list[item]['4s_price'] = info.price_4s
              }
            }else {
              goods_code_list.push({
                code: item,
                goods_cst_id: _data[items].goods_list[item].goods_cst_id,
                brandCode: _data[items].goods_list[item].data ? _data[items].goods_list[item].data.brandcode : ''
              })
            }
            
          })
        })
        if(goods_code_list.length > 0) {
          listApi.getAllGoods({
            goods_codes: goods_code_list,
            shop_search: 1
          }).then((res1: any) => {
            if(res1.code === 1) {
              let _data1 = res1.data
              Object.keys(_data).forEach((items: string) => {
                Object.keys(_data[items].goods_list).forEach((item: string) => {
                  if(_data[items].goods_list[item].stock_type !== 'epc' && _data[items].goods_list[item].stock_type !== 'yc'){
                    try{
                      _data[items].goods_list[item] = {
                        ..._data[items].goods_list[item],
                        ..._data1[_data[items].goods_list[item].goods_cst_id][item]
                      }
                      if(_data[items].goods_list[item].quality_price) {
                        price += _data[items].goods_list[item].quality_price * _data[items].goods_list[item].num
                      }
                    }catch(err) {
                      console.info(err)
                    }
                  }
                })
              })
            }
            setCommonStore({
              type: 'cartPrice',
              value: parseFloat(price.toFixed(2))
            })
          }).catch((err: any) => {
            setCommonStore({
              type: 'cartPrice',
              value: parseFloat(price.toFixed(2))
            })
          })
        }else {
          setCommonStore({
            type: 'cartPrice',
            value: parseFloat(price.toFixed(2))
          })
        }
        setCommonStore({
          type: 'cartNum',
          value: length 
        })
      }
    })
  }
  const arrawClick = (type: string) => {
    let fbrandlistDom: any = document.getElementById('fbrandlist-dom')
    let fbrandlistWrap: any = document.getElementById('fbrandlist-wrap')
    let wrapWidth = fbrandlistWrap && fbrandlistWrap.clientWidth ? fbrandlistWrap.clientWidth : 0
    let width = fbrandlistDom && fbrandlistDom.clientWidth ? fbrandlistDom.clientWidth : 0
    let scrollLeft = fbrandlistWrap && fbrandlistWrap.scrollLeft ? fbrandlistWrap.scrollLeft : 0
    console.log("scrollLeft:", scrollLeft)
    if(type === 'left') {
      let _translateX = translateX + 90
      if(_translateX >= 0) {
        _translateX = wrapWidth - width
      }
      setTranslateX(_translateX)
      fbrandlistWrap.scrollLeft = scrollLeft - 90
    }else if(type === 'right') {
      let _translateX = translateX - 90
      if(_translateX <= wrapWidth - width) {
        _translateX = 0
      }
      setTranslateX(_translateX)
      fbrandlistWrap.scrollLeft = scrollLeft + 90
    }
    
  }
  return (
    <div className={styles['boot']} style={{background: '#ffffff'}}>
      {
        pageType === '8' ? (
          <div className={styles['wrap1'] + ' flex-s-c'} style={{ width: 1240 }}>
            <div className={styles['wrap1-rt']} style={{ width: '100%', marginLeft: 0 }}>
              <div className={styles['list-head']} style={{ border: '1px solid #E0E0E0' }}>
                <div className={styles['head-lf']}> 
                  <Radio.Group 
                    onChange={sortTypeChange} 
                    value={sortType} 
                    style={{
                      display: 'flex',
                      gap: 2
                    }}
                  >
                    <Radio value='default'>{intl.formatMessage({id: '推荐排序'})}</Radio>
                    <Radio value='highToLow'>{intl.formatMessage({id: '价格由高到低'})}</Radio>
                    <Radio value='lowToHigh'>{intl.formatMessage({id: '价格由低到高'})}</Radio>
                  </Radio.Group> 
                  <Input.Search 
                  placeholder={intl.formatMessage({id: '零件名称/OE'})}
                  style={{width: 302}} 
                  value={partKey} 
                  onChange={e => setPartKey(e.target.value)}
                  onSearch={(value) => {setPartKeyword(value); setPager({page: 1, size: 60, total: 0})}}
                  />
                </div>
                <div className={styles['head-rt']}>
                  <span className={styles['total']}>{intl.formatMessage({ id: '总共' })}：{pager.total}</span>
                  <div style={{ display: 'flex' }}>
                    <Pagination 
                      simple
                      current={pager.page} 
                      total={pager.total} 
                      pageSize={pager.size}
                      // pageSizeOptions={[50, 60, 120, 180]}
                      onChange={pagerChange}
                    />
                    {/* <ConfigProvider
                      theme={{
                        components: {
                          Segmented: {
                            itemActiveBg: colorPrimary,
                            itemHoverBg: colorPrimary,
                            itemSelectedBg: colorPrimary,
                            itemHoverColor: '#ffffff',
                            itemSelectedColor: '#ffffff'
                          },
                        }
                      }}
                    >
                      <Segmented
                        value={listType}
                        onChange={(value) => setListType(value)}
                        options={[
                          { value: 'space', icon: <AppstoreOutlined /> },
                          { value: 'text', icon: <BarsOutlined /> },
                        ]}
                      />
                    </ConfigProvider> */}
                  </div>
                </div>
              </div>
              <Spin spinning={loading} delay={1000} indicator={<img src="https://cdns.007vin.com/img/autorepair/cst/car_loading.gif"/>} wrapperClassName={styles['list-spin']}>
                <div ref={spacelistRef}>
                  {
                    _part_list.length ? <div>
                      {
                        listType === 'space' ? <div className='flex-s-c p5' style={{ flexWrap: 'wrap' }} >
                          {
                            _part_list.map((item: any, index: number) => {
                            let dbj = token && (!item.quality_price || !item.goods_stock_num || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? true : false
                              return (
                                <Fragment key={index}>
                                  {
                                    item.type === 2 ? <div style={{ backgroundColor: '#F8F8F8' }} key={index} className={styles['item5'] + ' m5'} onClick={() => !dbj && toPartDtl(item)}>
                                      <div className={styles['img-wrap5']} >
                                        <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                      </div>
                                      <div className={styles['item-b5'] + ' p10'}>
                                        <div>
                                          <div className={styles['part-name'] + ' b'}>
                                            <Tooltip title={item.part_name}>
                                              <span>{item.part_name}</span>
                                            </Tooltip>
                                          </div>
                                          <div className={'color-8 mt10'}>
                                            {intl.formatMessage({id: '品牌'})}：REACH
                                            
                                          </div>
                                          <div className={'color-8 mt10'}>
                                            {intl.formatMessage({id: '商品编码'})}：<Copy icon={true} title={item.code} />
                                          </div>
                                          {
                                            showOe ? (
                                              <div className={'color-8 mt10'}>
                                                OE：
                                                {
                                                  item.quality_oe ? <Copy icon={true} title={item.quality_oe} /> : null
                                                }
                                              </div>
                                            ): null
                                          }
                                          
                                          {/* <div className='color-8 mt10'>
                                            <span>{intl.formatMessage({id: '商品编码'})}：</span><Copy icon={true} title={item.code} />
                                          </div> */}
                                          {
                                            commonStore.inventoryParams && commonStore.inventoryParams.stock_show ? <div className='color-8 mt10'>
                                              {intl.formatMessage({id: '库存'})}：{item.goods_stock_num ? intl.formatMessage({id: '有货'}) : intl.formatMessage({id: '缺货'})}
                                            </div> : null
                                          }
                                          
                                        </div>
                                        {
                                          token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show && commonStore.shop_discount ? <div className='mt10'>
                                            <div className={styles['discount-boot']}>
                                              <div className={styles['discount-wrap']}>
                                                <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                <div className={styles['price']}>
                                                  {priceUnit} &nbsp;
                                                  {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                </div>
                                              </div>
                                              <div className={styles['origin-price'] + ' mt5'}>
                                                {priceUnit} &nbsp;
                                                {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                              </div>
                                            </div>
                                          </div> : <div className='mt10' style={{height: commonStore.shop_discount ? 38 : 'auto'}}>
                                            {
                                              token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show ? <>
                                                <span className={styles['price']}>
                                                  {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                </span>
                                                {
                                                  item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                }
                                              </> : null
                                            }
                                            {/* {
                                              token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                            } */}
                                            {
                                              token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                            }
                                          </div>
                                        }
                                        <Button 
                                          onClick={(e: any) => addCart(e ,item)} 
                                          className='mt10' 
                                          style={{ width: '100%', background: '#fff', color: '#333333', opacity: dbj ? .6 : 1 }} 
                                          icon={<i className='icon iconfont icon-jiarugouwuche'/>} disabled={!dbj ? false : true}
                                        >
                                          {intl.formatMessage({ id: '加入购物车' })}
                                        </Button>
                                        
                                      </div>
                                    </div> : null
                                  }
                                  {
                                    item.type === 1 ? <div style={{ backgroundColor: '#F8F8F8' }} key={index} className={styles['item5'] + ' m5'} onClick={() => toPartDetail(item)}>
                                      <div className={styles['img-wrap5']} >
                                        <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                      </div>
                                      <div className={styles['item-b5'] + ' p10'}>
                                        <div>
                                          <div className={styles['part-name'] + ' b'}>
                                            <Tooltip title={item.label}>
                                              <span>{item.label}</span>
                                            </Tooltip>
                                          </div>
                                          {
                                            item.isDms && item.quality_name ? <div className={'color-8 mt10'}>
                                            {intl.formatMessage({id: '品牌'})}：{item.isDms ? item.quality_name : intl.formatMessage({id: '询价'})}
                                            </div> : null
                                          }
                                          {
                                            showOe ? (
                                              <div className={'color-8 mt10'}>
                                                OE：
                                                {
                                                  item.pid ? <Copy icon={true} title={item.pid} /> : null
                                                }
                                              </div>
                                            ): null
                                          }
                                          
                                          {/* <div className='color-8 mt10'>
                                            <span>{intl.formatMessage({id: '商品编码'})}：</span><Copy icon={true} title={item.code} />
                                          </div> */}
                                          {
                                            item.isDms && item.quality_name && commonStore.inventoryParams && commonStore.inventoryParams.stock_show ? <div className='color-8 mt10'>
                                              {intl.formatMessage({id: '库存'})}：{item.goods_stock_num ? intl.formatMessage({id: '有货'}) : intl.formatMessage({id: '缺货'})}
                                            </div> : null
                                          }
                                          
                                        </div>
                                        {
                                          token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show && commonStore.shop_discount ? <div className='mt10'>
                                            <div className={styles['discount-boot']}>
                                              <div className={styles['discount-wrap']}>
                                                <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                <div className={styles['price']}>
                                                  {priceUnit} &nbsp;
                                                  {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                </div>
                                              </div>
                                              <div className={styles['origin-price'] + ' mt5'}>
                                                {priceUnit} &nbsp;
                                                {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                              </div>
                                            </div>
                                          </div> : <div className='mt10' style={{height: commonStore.shop_discount ? 38 : 'auto'}}>
                                            {
                                              token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show ? <>
                                                <span className={styles['price']}>
                                                  {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                </span>
                                                {
                                                  item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                }
                                              </> : null
                                            }
                                            {/* {
                                              token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                            }
                                            {
                                              !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                            } */}
                                            {
                                              token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                            }
                                            
                                          </div>
                                        }
                                        <div className='mt10' >
                                          <Button 
                                            icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                            type="primary" 
                                            onClick={(e) => openAsstModal(e, {
                                              part_name: item.label,
                                              oe: item.pid ? item.pid : '',
                                              amount: item.goods_stock_num ? item.goods_stock_num : 1
                                            })}
                                          >
                                            {intl.formatMessage({ id: '加需求' })}
                                          </Button>
                                        </div>
                                      </div>
                                    </div> : null
                                  }
                                  {
                                    item.type === 0 ? <div style={{ backgroundColor: '#F8F8F8' }} key={index} className={styles['item5'] + ' m5'} onClick={() => toPartDtl(item)}>
                                      {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                      <div className={styles['img-wrap5']}>
                                        <img src="https://cdns.007vin.com/img/autorepair/cst/no_item.png" alt="" />
                                      </div>
                                      <div className={styles['item-b5'] + ' p10'}>
                                        <div>
                                          <div className={styles['part-name'] + ' b'}>
                                            <Tooltip title={item.label}>
                                              <span>{item.label}</span>
                                            </Tooltip>
                                          </div>
                                          {/* <div className={'color-8 mt10'}>
                                            {intl.formatMessage({id: '品牌'})}：{intl.formatMessage({id: '询价'})}
                                            
                                          </div> */}
                                          {
                                            showOe ? (
                                              <div className={'color-8 mt10'}>
                                                OE：
                                                {
                                                  item.pid ? <Copy icon={true} title={item.pid} /> : null
                                                }
                                              </div>
                                            ): null
                                          }
                                          
                                          {/* <div className='color-8 mt10'>
                                            <span>{intl.formatMessage({id: '商品编码'})}：</span><Copy icon={true} title={item.code} />
                                          </div> */}
                                          {/* {
                                            commonStore.inventoryParams && commonStore.inventoryParams.stock_show && commonStore.inventoryParams && commonStore.inventoryParams.price_show ? <div className='color-8 mt10'>
                                              {intl.formatMessage({id: '库存'})}：{item.goods_stock_num ? intl.formatMessage({id: '有货'}) : intl.formatMessage({id: '缺货'})}
                                            </div> : null
                                          } */}
                                          
                                        </div>
                                        <div className='mt10' style={{height: commonStore.shop_discount ? 38 : 'auto'}}>
                                          {/* <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> */}
                                        </div>
                                        <div className='mt10' >
                                          <Button 
                                            icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                            type="primary" 
                                            onClick={(e) => openAsstModal(e, {
                                              part_name: item.label,
                                              oe: item.pid ? item.pid : '',
                                              amount: item.goods_stock_num ? item.goods_stock_num : 1
                                            })}
                                          >
                                            {intl.formatMessage({ id: '加需求' })}
                                          </Button>
                                        </div>
                                        
                                        {/* <Button onClick={(e: any) => addCart(e ,item)} className='mt10' style={{ width: '100%', background: '#fff', color: '#333333' }} icon={<i className='icon iconfont icon-jiarugouwuche'/>} disabled={item.goods_stock_num || true ? false : true}>
                                          {intl.formatMessage({ id: '加入购物车' })}
                                        </Button> */}
                                      </div>
                                    </div> : null
                                  }
                                </Fragment>
                                
                              )
                            })
                          }
                        </div> : <div className={styles['text-list']}>
                          {
                            _part_list.map((item: any, index: number) => {
                              let dbj = token && (!item.quality_price || !item.goods_stock_num || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? true : false
                              return (
                                <Fragment key={index}>
                                  {
                                    item.type === 2 ? <div className={styles['item3']} key={index} onClick={() => toPartDtl(item)}>
                                      <div className={styles['item-lf']}>
                                        <div className={styles['img-wrap']} style={{ marginRight: 40 }}>
                                          <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                        </div>
                                        <div>
                                          <div className={styles['row2'] + ' mb15'} style={{ color: '#333333', fontSize: 14, fontWeight: 500 }}>
                                            {item.quality_name}{item.quality_name && item.part_name ? '·' : ''}{item.part_name}
                                          </div>
                                          <div className={styles['row2']} style={{marginBottom: 15}}>
                                            <div className='flex-s-c flex-wrap' style={{ color: '#666666', fontSize: 14 }}>
                                              <span>{intl.formatMessage({id: '商品编码'})}：</span>
                                              <span>
                                                <Copy icon={true} title={item.code} />
                                              </span>
                                            </div>
                                          </div>
                                          {
                                            item.quality_oe ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                              <span>{intl.formatMessage({id: '原厂OE'})}：</span>
                                              <span className={styles['oe']}>
                                                {
                                                  item.quality_oe ? <Copy icon={true} title={item.quality_oe} /> : null
                                                }
                                              </span>
                                            </div> : null
                                          }
                                          {
                                            item.warranty ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                              <span>{intl.formatMessage({id: '质保'})}：</span>
                                              <span>
                                                {item.warranty}
                                              </span>
                                            </div> : null
                                          }
                                          
                                        </div>
                                      </div>
                                      <div className={styles['item-rt']}>
                                        {
                                          token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.shop_discount ? <div className={styles['row2'] + ' mb15'}>
                                            <div className={styles['discount-boot']}>
                                              <div className={styles['discount-wrap']}>
                                                <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                <div className={styles['price']}>
                                                  {priceUnit} &nbsp;
                                                  {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                </div>
                                              </div>
                                              <div className={styles['origin-price'] + ' mt5'}>
                                                {priceUnit} &nbsp;
                                                {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                              </div>
                                            </div>
                                          </div> : <div className={styles['row2'] + ' mb15'}>
                                            {
                                              token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <span className={styles['price']}>
                                                {priceUnit}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                              </span> : null
                                            }
                                            {/* {
                                              token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                            }
                                            {
                                              !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                            } */}
                                            {
                                              token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                            }
                                            {
                                              token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                            }
                                            
                                          </div>
                                        }
                                        
                                        {
                                          item.pay_count > 0 ? <div className={styles['pay-count'] + ' mb15'}>{item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}</div> : null
                                        }
                                        <div>
                                          <Button 
                                            onClick={(e: any) => addCart(e ,item)} 
                                            className='mt10' 
                                            style={{ width: 150 }} 
                                            type="primary" 
                                            icon={<i className='icon iconfont icon-jiarugouwuche'/>}
                                            disabled={!dbj ? false : true}
                                          ></Button>
                                        </div>
                                      </div>
                                    </div> : null
                                  }
                                  {
                                    item.type === 1 ? <div className={styles['item3']} key={index} onClick={() => toPartDetail(item)}>
                                      <div className={styles['item-lf']}>
                                        <div className={styles['img-wrap']} style={{ marginRight: 40 }}>
                                          <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                        </div>
                                        <div>
                                          <div className={styles['row2'] + ' mb15'} style={{ color: '#333333', fontSize: 14, fontWeight: 500 }}>
                                          {item.isDms ? item.quality_name : ''} {item.label || item.pid ? '·' : ''} {item.label ? item.label : item.pid}
                                          </div>
                                          {
                                            item.code ? <div className={styles['row2']} style={{marginBottom: 15}}>
                                              <div className='flex-s-c flex-wrap' style={{ color: '#666666', fontSize: 14 }}>
                                                <span>{intl.formatMessage({id: '商品编码'})}：</span>
                                                <span>
                                                  <Copy icon={true} title={item.code} />
                                                </span>
                                              </div>
                                            </div> : null
                                          }
                                          {
                                            item.pid  ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                              <span>{intl.formatMessage({id: '原厂OE'})}：</span>
                                              <span className={styles['oe']}>
                                                {
                                                  item.pid  ? <Copy icon={true} title={item.pid} /> : null
                                                }
                                              </span>
                                            </div> : null
                                          }
                                          {
                                            item.warranty ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                              <span>{intl.formatMessage({id: '质保'})}：</span>
                                              <span>
                                                {item.warranty}
                                              </span>
                                            </div> : null
                                          }
                                          
                                        </div>
                                      </div>
                                      <div className={styles['item-rt']}>
                                        {
                                          token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.shop_discount ? <div className={styles['row2'] + ' mb15'}>
                                            <div className={styles['discount-boot']}>
                                              <div className={styles['discount-wrap']}>
                                                <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                <div className={styles['price']}>
                                                  {priceUnit} &nbsp;
                                                  {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                </div>
                                              </div>
                                              <div className={styles['origin-price'] + ' mt5'}>
                                                {priceUnit} &nbsp;
                                                {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                              </div>
                                            </div>
                                          </div> : <div className={styles['row2'] + ' mb15'}>
                                            {
                                              token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <div style={{display: 'flex', alignItems: 'center'}}>
                                                <span className={styles['price']}>
                                                  {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                </span>
                                                {
                                                  item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                }
                                              </div> : null
                                            }
                                            {/* {
                                              token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) ? <span className={styles['quoted']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                            } */}
                                            {
                                              token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                            }
                                            <Button
                                              className='mt10' 
                                              icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                              type="primary" 
                                              onClick={(e) => openAsstModal(e, {
                                                part_name: item.label,
                                                oe: item.pid ? item.pid : '',
                                                amount: item.goods_stock_num ? item.goods_stock_num : 1
                                              })}
                                            >
                                              {intl.formatMessage({ id: '加需求' })}
                                            </Button>
                                          </div>
                                        }
                                        
                                        {
                                          item.pay_count > 0 ? <div className={styles['pay-count'] + ' mb15'}>{item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}</div> : null
                                        }
                                      {/*  <div>
                                          <Button onClick={(e: any) => addCart(e ,item)} className='mt10' style={{ width: 150 }} type="primary" icon={<i className='icon iconfont icon-jiarugouwuche'/>}></Button>
                                        </div> */}
                                      </div>
                                    </div> : null
                                  }
                                  {
                                    item.type === 0 ? <div className={styles['item3']} key={index} onClick={() => toPidDtl(item)}>
                                      <div className={styles['item-lf']}>
                                        <div className={styles['img-wrap']} style={{ marginRight: 40 }}>
                                          <img src='https://cdns.007vin.com/img/autorepair/cst/no_item.png' alt="" />
                                        </div>
                                        <div>
                                          <div className={styles['row2'] + ' mb15'} style={{ color: '#333333', fontSize: 14, fontWeight: 500 }}>
                                          {item.label}
                                          </div>
                                          {
                                            item.pid ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                              <span>{intl.formatMessage({id: '原厂OE'})}：</span>
                                              <span className={styles['oe']}>
                                                {
                                                  item.pid ? <Copy icon={true} title={item.pid} /> : null
                                                }
                                              </span>
                                            </div> : null
                                          }
                                          {
                                            item.warranty ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                              <span>{intl.formatMessage({id: '质保'})}：</span>
                                              <span>
                                                {item.warranty}
                                              </span>
                                            </div> : null
                                          }
                                          
                                        </div>
                                      </div>
                                      <div className={styles['item-rt']}>
                                        <div className={styles['row2'] + ' mb15'}>
                                          {/* <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> */}
                                        </div>
                                        {
                                          item.pay_count > 0 ? <div className={styles['pay-count'] + ' mb15'}>{item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}</div> : null
                                        }
                                        <div>
                                          {/* <Button onClick={(e: any) => addCart(e ,item)} className='mt10' style={{ width: 150 }} type="primary" icon={<i className='icon iconfont icon-jiarugouwuche'/>}></Button> */}
                                          <Button 
                                            className='mt10' 
                                            icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                            type="primary"
                                            onClick={(e) => openAsstModal(e, {
                                              part_name: item.label,
                                              oe: item.pid ? item.pid : '',
                                              amount: item.goods_stock_num ? item.goods_stock_num : 1
                                            })}
                                          >
                                            {intl.formatMessage({ id: '加需求' })}
                                          </Button>
                                        </div>
                                      </div>
                                    </div> : null
                                  }
                                </Fragment>
                                
                              )
                            })
                          }
                        </div>
                          
                      }
                      <div className={styles['pager'] + ' flex-c-c'}>
                        <Pagination 
                          current={pager.page} 
                          total={pager.total} 
                          pageSize={pager.size}
                          pageSizeOptions={[50, 60, 120, 180]}
                          onChange={pagerChange}
                        />
                      </div>
                    </div> : <div>
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={intl.formatMessage({id: '暂无数据'})}/>
                    </div>
                  }
                </div>
              </Spin>
            </div>
          </div>
        ) : pageType === '6' ? <div className={styles['wrap1'] + ' flex-s-c'}>
          <div className={styles['wrap1-lf']}>
            <VinDomain vinKeyword='' info={{}}/>
            <div className={styles['sort-wrap'] + ' mt10'}>
              <div className={styles['sort-title']}>{intl.formatMessage({id: '排序方式'})}</div>
              <Radio.Group 
                onChange={sortTypeChange} 
                value={sortType} 
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 8
                }}
              >
                <Radio value='default'>{intl.formatMessage({id: '推荐排序'})}</Radio>
                <Radio value='highToLow'>{intl.formatMessage({id: '价格由高到低'})}</Radio>
                <Radio value='lowToHigh'>{intl.formatMessage({id: '价格由低到高'})}</Radio>
              </Radio.Group> 
            </div>
          </div>
          <div className={styles['wrap1-rt']}>
            {
              !isCst  ? <div className={styles['f-brand-list']} style={{marginTop: 0}}>
                <span className={styles['title']}>{intl.formatMessage({id: '自定义标签'})}：</span>
                <div className={styles['wrap-brand-list-6']}>
                  <div className={styles['arraw-btn']}><LeftOutlined style={{fontSize: 12, color: '#E0E0E0'}} onClick={() => arrawClick('left')}/></div>
                  <div className={styles['brand-list-wrap']} id="fbrandlist-wrap">
                    <div 
                      className={styles['brand-list-6']} 
                      id="fbrandlist-dom" 
                      // style={{transition: 'transform 2s', transform: 'translateX(' + translateX + 'px)'}}
                    >
                      <div 
                        className={styles['brand-item'] + ' ' +  `${!activeFbrand[0] ? styles['active'] : ''}` } 
                        onClick={() => { handleFbrand({ name: '', logo_url: '' }) }}
                        style={{color: !activeFbrand[0] ? colorPrimary : '#333333', borderColor: !activeFbrand[0] ? colorPrimary : '#E0E0E0'}}
                        data-has-image={false}
                      >
                        <span >{intl.formatMessage({ id: '全部' })}</span>
                        {
                          !activeFbrand[0] ? <i className={styles['selected'] + " icon iconfont icon-xuanzhong"} style={{fontSize: 16, color: colorPrimary}}></i> : null
                        }
                      </div>
                      {
                        fbrandList.map((item: any, index: number) => {
                          return (
                            <div 
                              key={index} 
                              onClick={() => { handleFbrand(item) }} 
                              className={activeFbrand[0] && activeFbrand[0] === item.name ? `${styles['brand-item']} ${styles['active']} ${item.logo_url ? styles['has-image'] : styles['no-image']}` : `${styles['brand-item']} ${item.logo_url ? styles['has-image'] : styles['no-image']}`}
                              style={{color: activeFbrand[0] && activeFbrand[0] === item.name ? colorPrimary : '#333333', borderColor:  activeFbrand[0] && activeFbrand[0] === item.name ? colorPrimary : '#E0E0E0'}}
                              data-has-image={!!item.logo_url}
                            >
                              {item.logo_url && (
                                <img 
                                  src={item.logo_url} 
                                  className={styles['logo']}
                                  alt={item.name} 
                                  style={{ height: "30px" }}
                                />
                              )}
                              <span className={styles['name']}>{capitalizeFirstLetter(item.name) || intl.formatMessage({ id: '全部' })}</span>
                              {
                                activeFbrand[0] && activeFbrand[0] === item.name ? <i className={styles['selected'] + " icon iconfont icon-xuanzhong"} style={{fontSize: 16, color: colorPrimary}}></i> : null
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                  <div className={styles['arraw-btn']} onClick={() => arrawClick('right')}><RightOutlined style={{fontSize: 12, color: '#E0E0E0'}}/></div>
                </div>
              </div> : null
            }
            {
              selectArr.length ? <div className='flex ptb10 plr10 mb10 mt10' style={{ fontSize: 12, color: '#333333', background: '#fff', height: selectArr.length > 32 ? (isMore ? 'max-content' : '80px') : 'max-content', overflow: 'hidden' }}>
                <div style={{lineHeight: '17px'}}>{intl.formatMessage({ id: '查询结果' })}：</div>
                <div className='flex-s-c' style={{ flexWrap: 'wrap', width: selectArr.length > 32 ? 'calc(100% - 100px)' : 'calc(100% - 70px)' }}>
                  <div onClick={() => setSelectA("")} className='mr10 pointer' style={{ background: selectA === "" ? colorPrimary : '', color: selectA === "" ? (fontColorPrimary ? fontColorPrimary : "#ffffff") : '#333333', padding: '2px 5px' }}>{intl.formatMessage({ id: '全部' })}</div>
                  {
                    selectArr.map((it: any, i: number) => {
                      return (
                        <div onClick={() => setSelectA(it)} className='mr10 pointer' key={i} style={{ background: selectA === it ? colorPrimary : '', color: selectA === it ? (fontColorPrimary ? fontColorPrimary : "#ffffff") : '#333333', padding: '2px 5px' }} >{it}</div>
                      )
                    })
                  }
                </div>
                {
                  selectArr.length > 32 ? <span style={{cursor: 'pointer', color: '#096BED'}} onClick={() => setIsMore(!isMore)}>{intl.formatMessage({id: '更多'})}</span> : null
                }
              </div> : null
            }
            
            <div className={styles['list-head']}>
              <div className={styles['head-lf']}> 
                <Input.Search 
                placeholder={intl.formatMessage({id: '零件名称/OE'})}
                style={{width: 302}} 
                value={partKey} 
                onChange={e => setPartKey(e.target.value)}
                onSearch={(value) => {setPartKeyword(value); setPager({page: 1, size: 60, total: 0})}}
                />
              </div>
              <div className={styles['head-rt']}>
                <span className={styles['total']}>{intl.formatMessage({ id: '总共' })}：{pager.total}</span>
                <div style={{ display: 'flex' }}>
                  <ConfigProvider
                    theme={{
                      components: {
                        Segmented: {
                          /* 这里是你的组件 token */
                          itemActiveBg: colorPrimary,
                          itemHoverBg: colorPrimary,
                          itemSelectedBg: colorPrimary,
                          itemHoverColor: fontColorPrimary ? fontColorPrimary : '#ffffff',
                          itemSelectedColor: fontColorPrimary ? fontColorPrimary : '#ffffff'
                        },
                      }
                    }}
                  >
                    <Segmented
                      value={listType}
                      onChange={(value) => setListType(value)}
                      options={[
                        { value: 'space', icon: <AppstoreOutlined /> },
                        { value: 'text', icon: <BarsOutlined /> },
                      ]}
                    />
                  </ConfigProvider>
                </div>
              </div>
            </div>

            <Spin spinning={loading} delay={1000} indicator={<img src="https://cdns.007vin.com/img/autorepair/cst/car_loading.gif"/>} wrapperClassName={styles['list-spin']}>
              <div ref={spacelistRef}>
                {
                  _part_list.length ? <div>
                    {
                      listType === 'space' ? <div className='flex-s-c p5' style={{ flexWrap: 'wrap' }} >
                        {
                          _part_list.map((item: any, index: number) => {
                            let dbj = token && (!item.quality_price || !item.goods_stock_num || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? true : false
                            return (
                              <Fragment key={index}>
                                {
                                  item.type === 2 ? <div key={index} className={styles['item5'] + ' m5'} onClick={() => toPartDtl(item)}>
                                    <div className={styles['img-wrap5']}>
                                      <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                    </div>
                                    <div className={styles['item-b5'] + ' p10'}>
                                      <div>
                                        <div className={styles['part-name'] + ' b'}>
                                          <Tooltip title={item.part_name}>
                                            <span>{item.part_name}</span>
                                          </Tooltip>
                                        </div>
                                        <div className={'color-8 mt10'}>
                                          {intl.formatMessage({id: '品牌'})}：{item.quality_name}
                                          
                                        </div>
                                        {
                                          showOe ? (
                                            <div className={'color-8 mt10'}>
                                              OE：
                                              {
                                                item.quality_oe ? <Copy icon={true} title={item.quality_oe} /> : null
                                              }
                                            </div>
                                          ): null
                                        }
                                        
                                        <div className='color-8 mt10' style={{height: 34, lineHeight: '17px'}}>
                                          <span>{intl.formatMessage({id: '商品编码'})}：</span><Copy icon={true} title={item.code} />
                                        </div>
                                        {
                                          commonStore.inventoryParams && commonStore.inventoryParams.stock_show ? <div className='color-8 mt10'>
                                            {intl.formatMessage({id: '库存'})}：{item.goods_stock_num ? intl.formatMessage({id: '有货'}) : intl.formatMessage({id: '缺货'})}
                                          </div> : null
                                        }
                                        
                                      </div>
                                      {
                                        token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show && commonStore.shop_discount ? <div className='mt10'>
                                          <div className={styles['discount-boot']}>
                                            <div className={styles['discount-wrap']}>
                                              <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                              <div className={styles['price']}>
                                                {priceUnit} &nbsp;
                                                {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                              </div>
                                            </div>
                                            <div className={styles['origin-price'] + ' mt5'}>
                                              {priceUnit} &nbsp;
                                              {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                            </div>
                                          </div>
                                        </div> : <div className='mt10' style={{height: commonStore.shop_discount ? 38 : 'auto'}}>
                                          {
                                            token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show ? <>
                                              <span className={styles['price']}>
                                                {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                              </span>
                                              {
                                                item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                              }
                                            </> : null
                                          }
                                          {/* {
                                            token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                          } */}
                                          {
                                            token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                          }
                                        </div>
                                      }
                                      <Button 
                                        onClick={(e: any) => addCart(e ,item)} 
                                        className='mt10' 
                                        style={{ width: '100%' }} 
                                        type="primary" 
                                        icon={<i className='icon iconfont icon-jiarugouwuche'/>}
                                        disabled={!dbj ? false : true}
                                      ></Button>
                                    </div>
                                  </div> : null
                                }
                                {
                                  item.type === 1 ? <div key={index} className={styles['item5'] + ' m5'} onClick={() => toPartDetail(item)}>
                                    <div className={styles['img-wrap5']}>
                                      <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                    </div>
                                    <div className={styles['item-b5'] + ' p10'}>
                                      <div>
                                        <div className={styles['part-name'] + ' b'}>
                                          <Tooltip title={item.label}>
                                            <span>{item.label}</span>
                                          </Tooltip>
                                        </div>
                                        <div className={'color-8 mt10'}>
                                          {intl.formatMessage({id: '品牌'})}：{item.isDms ? item.quality_name : ''}
                                        </div>
                                        {
                                          showOe ? (
                                            <div className={'color-8 mt10'}>
                                              OE：
                                              {
                                                item.pid ? <Copy icon={true} title={item.pid} /> : null
                                              }
                                            </div>
                                          ): null
                                        }
                                        
                                        {/* <div className='color-8 mt10'>
                                          <span>{intl.formatMessage({id: '商品编码'})}：</span><Copy icon={true} title={item.code} />
                                        </div> */}
                                        {
                                          item.isDms && item.quality_name && commonStore.inventoryParams && commonStore.inventoryParams.stock_show ? <div className='color-8 mt10'>
                                            {intl.formatMessage({id: '库存'})}：{item.goods_stock_num ? intl.formatMessage({id: '有货'}) : intl.formatMessage({id: '缺货'})}
                                          </div> : null
                                        }
                                        
                                      </div>
                                      {
                                        token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show && commonStore.shop_discount ? <div className='mt10'>
                                          <div className={styles['discount-boot']}>
                                            <div className={styles['discount-wrap']}>
                                              <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                              <div className={styles['price']}>
                                                {priceUnit} &nbsp;
                                                {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                              </div>
                                            </div>
                                            <div className={styles['origin-price'] + ' mt5'}>
                                              {priceUnit} &nbsp;
                                              {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                            </div>
                                          </div>
                                        </div> : <div className='mt10' style={{height: commonStore.shop_discount ? 38 : 'auto'}}>
                                          {
                                            token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show ? <>
                                              <span className={styles['price']}>
                                                {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                              </span>
                                              {
                                                item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                              }
                                            </> : null
                                          }
                                          {/* {
                                            token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                          }
                                          {
                                            !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                          } */}
                                          {
                                            token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                          }
                                          
                                        </div>
                                      }
                                      <Button 
                                        className='mt10'
                                        style={{ width: '100%' }}
                                        icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                        type="primary"
                                        onClick={(e) => openAsstModal(e, {
                                          part_name: item.label,
                                          oe: item.pid ? item.pid : '',
                                          amount: item.goods_stock_num ? item.goods_stock_num : 1
                                        })}
                                      >
                                        {intl.formatMessage({ id: '加需求' })}
                                      </Button>
                                    </div>
                                  </div> : null
                                }
                                {
                                  item.type === 0 ? <div key={index} className={styles['item5'] + ' m5'} onClick={() => toPartDtl(item)}>
                                    {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                    <div className={styles['img-wrap5']}>
                                      <img src="https://cdns.007vin.com/img/autorepair/cst/no_item.png" alt="" />
                                    </div>
                                    <div className={styles['item-b5'] + ' p10'}>
                                      <div>
                                        <div className={styles['part-name'] + ' b'}>
                                          <Tooltip title={item.label}>
                                            <span>{item.label}</span>
                                          </Tooltip>
                                        </div>
                                        {/* <div className={'color-8 mt10'}>
                                          {intl.formatMessage({id: '品牌'})}：{intl.formatMessage({id: '询价'})}
                                          
                                        </div> */}
                                        {
                                          showOe ? (
                                            <div className={'color-8 mt10'}>
                                              OE：
                                              {
                                                item.pid ? <Copy icon={true} title={item.pid} /> : null
                                              }
                                            </div>
                                          ): null
                                        }
                                        
                                        {/* <div className='color-8 mt10'>
                                          <span>{intl.formatMessage({id: '商品编码'})}：</span><Copy icon={true} title={item.code} />
                                        </div> */}
                                        {/* {
                                          commonStore.inventoryParams && commonStore.inventoryParams.stock_show ? <div className='color-8 mt10'>
                                            {intl.formatMessage({id: '库存'})}：{item.goods_stock_num ? intl.formatMessage({id: '有货'}) : intl.formatMessage({id: '缺货'})}
                                          </div> : null
                                        } */}
                                        
                                      </div>
                                      <div className='mt10' style={{height: commonStore.shop_discount ? 38 : 'auto'}}>
                                        {/* <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> */}
                                      </div>
                                      
                                      {/* <Button onClick={(e: any) => addCart(e ,item)} className='mt10' style={{ width: '100%' }} type="primary" icon={<i className='icon iconfont icon-jiarugouwuche'/>}></Button> */}
                                      <Button 
                                        className='mt10'
                                        style={{ width: '100%' }}
                                        icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                        type="primary"
                                        onClick={(e) => openAsstModal(e, {
                                          part_name: item.label,
                                          oe: item.pid ? item.pid : '',
                                          amount: item.goods_stock_num ? item.goods_stock_num : 1
                                        })}
                                      >
                                        {intl.formatMessage({ id: '加需求' })}
                                      </Button>
                                      
                                    </div>
                                  </div> : null
                                }
                              </Fragment>
                              
                            )
                          })
                        }
                      </div> : <div className={styles['text-list']}>
                        {
                          _part_list.map((item: any, index: number) => {
                            let dbj = token && (!item.quality_price || !item.goods_stock_num || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? true : false
                            return (
                              <Fragment key={index}>
                                {
                                  item.type === 2 ? <div className={styles['item3']} key={index} onClick={() => toPartDtl(item)}>
                                    <div className={styles['item-lf']}>
                                      <div className={styles['img-wrap']} style={{ marginRight: 40 }}>
                                        <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                      </div>
                                      <div>
                                        <div className={styles['row2'] + ' mb15'} style={{ color: '#333333', fontSize: 14, fontWeight: 500 }}>
                                          {item.quality_name}{item.quality_name && item.part_name ? '·' : ''}{item.part_name}
                                        </div>
                                        <div className={styles['row2']} style={{marginBottom: 15}}>
                                          <div className='flex-s-c flex-wrap' style={{ color: '#666666', fontSize: 14 }}>
                                            <span>{intl.formatMessage({id: '商品编码'})}：</span>
                                            <span>
                                              <Copy icon={true} title={item.code} />
                                            </span>
                                          </div>
                                        </div>
                                        {
                                          item.quality_oe ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                            <span>{intl.formatMessage({id: '原厂OE'})}：</span>
                                            <span className={styles['oe']}>
                                              {
                                                item.quality_oe ? <Copy icon={true} title={item.quality_oe} /> : null
                                              }
                                            </span>
                                          </div> : null
                                        }
                                        {
                                          item.warranty ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                            <span>{intl.formatMessage({id: '质保'})}：</span>
                                            <span>
                                              {item.warranty}
                                            </span>
                                          </div> : null
                                        }
                                        
                                      </div>
                                    </div>
                                    <div className={styles['item-rt']}>
                                      {
                                        token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.shop_discount ? <div className={styles['row2'] + ' mb15'}>
                                          <div className={styles['discount-boot']}>
                                            <div className={styles['discount-wrap']}>
                                              <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                              <div className={styles['price']}>
                                                {priceUnit} &nbsp;
                                                {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                              </div>
                                            </div>
                                            <div className={styles['origin-price'] + ' mt5'}>
                                              {priceUnit} &nbsp;
                                              {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                            </div>
                                          </div>
                                        </div> : <div className={styles['row2'] + ' mb15'}>
                                          {
                                            token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <span className={styles['price']}>
                                              {priceUnit}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                            </span> : null
                                          }
                                          {/* {
                                            token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                          }
                                          {
                                            !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                          } */}
                                          {
                                            token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                          }
                                          {
                                            token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                          }
                                          
                                        </div>
                                      }
                                      
                                      {
                                        item.pay_count > 0 ? <div className={styles['pay-count'] + ' mb15'}>{item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}</div> : null
                                      }
                                      <div>
                                        <Button 
                                          onClick={(e: any) => addCart(e ,item)} 
                                          className='mt10' 
                                          style={{ width: 150 }} 
                                          type="primary" 
                                          icon={<i className='icon iconfont icon-jiarugouwuche'/>}
                                          disabled={!dbj ? false : true}
                                        ></Button>
                                      </div>
                                    </div>
                                  </div> : null
                                }
                                {
                                  item.type === 1 ? <div className={styles['item3']} key={index} onClick={() => toPartDetail(item)}>
                                    <div className={styles['item-lf']}>
                                      <div className={styles['img-wrap']} style={{ marginRight: 40 }}>
                                        <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                      </div>
                                      <div>
                                        <div className={styles['row2'] + ' mb15'} style={{ color: '#333333', fontSize: 14, fontWeight: 500 }}>
                                        {item.isDms ? item.quality_name : ''} {item.label || item.pid ? '·' : ''} {item.label ? item.label : item.pid}
                                        </div>
                                        {
                                          item.code ? <div className={styles['row2']} style={{marginBottom: 15}}>
                                            <div className='flex-s-c flex-wrap' style={{ color: '#666666', fontSize: 14 }}>
                                              <span>{intl.formatMessage({id: '商品编码'})}：</span>
                                              <span>
                                                <Copy icon={true} title={item.code} />
                                              </span>
                                            </div>
                                          </div> : null
                                        }
                                        {
                                          item.pid  ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                            <span>{intl.formatMessage({id: '原厂OE'})}：</span>
                                            <span className={styles['oe']}>
                                              {
                                                item.pid  ? <Copy icon={true} title={item.pid} /> : null
                                              }
                                            </span>
                                          </div> : null
                                        }
                                        {
                                          item.warranty ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                            <span>{intl.formatMessage({id: '质保'})}：</span>
                                            <span>
                                              {item.warranty}
                                            </span>
                                          </div> : null
                                        }
                                        
                                      </div>
                                    </div>
                                    <div className={styles['item-rt']}>
                                      {
                                        token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.shop_discount ? <div className={styles['row2'] + ' mb15'}>
                                          <div className={styles['discount-boot']}>
                                            <div className={styles['discount-wrap']}>
                                              <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                              <div className={styles['price']}>
                                                {priceUnit} &nbsp;
                                                {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                              </div>
                                            </div>
                                            <div className={styles['origin-price'] + ' mt5'}>
                                              {priceUnit} &nbsp;
                                              {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                            </div>
                                          </div>
                                        </div> : <div className={styles['row2'] + ' mb15'}>
                                          {
                                            token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <div style={{display: 'flex', alignItems: 'center'}}>
                                              <span className={styles['price']}>
                                                {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                              </span>
                                              {
                                                item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                              }
                                            </div> : null
                                          }
                                          {/* {
                                            token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) ? <span className={styles['quoted']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                          } */}
                                          {
                                            token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                          }
                                          <Button 
                                            className='mt10' 
                                            icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                            type="primary"
                                            onClick={(e) => openAsstModal(e, {
                                              part_name: item.label,
                                              oe: item.pid ? item.pid : '',
                                              amount: item.goods_stock_num ? item.goods_stock_num : 1
                                            })}
                                          >
                                            {intl.formatMessage({ id: '加需求' })}
                                          </Button>
                                        </div>
                                      }
                                      
                                      {
                                        item.pay_count > 0 ? <div className={styles['pay-count'] + ' mb15'}>{item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}</div> : null
                                      }
                                     {/*  <div>
                                        <Button onClick={(e: any) => addCart(e ,item)} className='mt10' style={{ width: 150 }} type="primary" icon={<i className='icon iconfont icon-jiarugouwuche'/>}></Button>
                                      </div> */}
                                    </div>
                                  </div> : null
                                }
                                {
                                  item.type === 0 ? <div className={styles['item3']} key={index} onClick={() => toPidDtl(item)}>
                                    <div className={styles['item-lf']}>
                                      <div className={styles['img-wrap']} style={{ marginRight: 40 }}>
                                        <img src='https://cdns.007vin.com/img/autorepair/cst/no_item.png' alt="" />
                                      </div>
                                      <div>
                                        <div className={styles['row2'] + ' mb15'} style={{ color: '#333333', fontSize: 14, fontWeight: 500 }}>
                                        {item.label}
                                        </div>
                                        {
                                          item.pid ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                            <span>{intl.formatMessage({id: '原厂OE'})}：</span>
                                            <span className={styles['oe']}>
                                              {
                                                item.pid ? <Copy icon={true} title={item.pid} /> : null
                                              }
                                            </span>
                                          </div> : null
                                        }
                                        {
                                          item.warranty ? <div className={styles['row2'] + ' mb15'} style={{ color: '#666666', fontSize: 14 }}>
                                            <span>{intl.formatMessage({id: '质保'})}：</span>
                                            <span>
                                              {item.warranty}
                                            </span>
                                          </div> : null
                                        }
                                        
                                      </div>
                                    </div>
                                    <div className={styles['item-rt']}>
                                      <div className={styles['row2'] + ' mb15'}>
                                        {/* <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> */}
                                      </div>
                                      {
                                        item.pay_count > 0 ? <div className={styles['pay-count'] + ' mb15'}>{item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}</div> : null
                                      }
                                      <div>
                                        {/* <Button onClick={(e: any) => addCart(e ,item)} className='mt10' style={{ width: 150 }} type="primary" icon={<i className='icon iconfont icon-jiarugouwuche'/>}></Button> */}
                                        <Button 
                                          className='mt10' 
                                          icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                          type="primary"
                                          onClick={(e) => openAsstModal(e, {
                                            part_name: item.label,
                                            oe: item.pid ? item.pid : '',
                                            amount: item.goods_stock_num ? item.goods_stock_num : 1
                                          })}
                                        >
                                          {intl.formatMessage({ id: '加需求' })}
                                        </Button>
                                      </div>
                                    </div>
                                  </div> : null
                                }
                              </Fragment>
                              
                            )
                          })
                        }
                      </div>
                        
                    }
                    <div className={styles['pager']}>
                      <Pagination 
                        current={pager.page} 
                        total={pager.total} 
                        pageSize={pager.size}
                        pageSizeOptions={[50, 60, 120, 180]}
                        onChange={pagerChange}
                      />
                    </div>
                  </div> : <div>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={intl.formatMessage({id: '暂无数据'})}/>
                  </div>
                }
              </div>
            </Spin>
          </div>
        </div> : <div className={styles['wrap3']}>
          {
            pageType === '1' || pageType === '2' || pageType === '4' ? <div className={styles['wrap-head'] + ' ' + `${pageType === '5' ? styles['wrap-head-5'] : ''}`} style={{justifyContent: 'space-between', padding: 5}}>
              <div className={styles['oe-head']}>
                <Input.TextArea
                  allowClear
                  style={{width: 518, height: 70}}
                  autoSize={{ minRows: 3, maxRows: 10 }}
                  placeholder={intl.formatMessage({id: 'OE/编码/零件名称搜索，多零件号请换行'})}
                  value={keyword}
                  onChange={inputChange} 
                />
                <Button type="primary" style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}} icon={<SearchOutlined />} loading={loading} onClick={() => searchOeInput(keyword)}></Button>
              </div>
              <div className={styles['history-list']  + ' ' + `${pageType === '5' ? styles['history-list-5'] : ''}`}>
                {
                  oeHistory.length > 0 ? <div className={styles['title']} onClick={() => toPartHistory()}>{intl.formatMessage({id: '查询历史'})}</div> : null
                }
                {
                  oeHistory.map((item: any, index: number) => {
                    if(index>=2) return null
                    return (
                      <div className={styles['history-item']} key={index} onClick={()=>oeItemClick(item)}>
                        <span>{item.keyword}</span>
                      </div>
                    )
                  })
                }
                {
                  oeHistory.length > 0 ? <div className={styles['history-more']} onClick={toHistoryMore} style={{color: colorPrimary}}>{intl.formatMessage({id: '更多'})}&gt;</div> : null
                }
              </div>
              
            </div> : null
          }
          
          <div className='pt10 pb10' style={{background: '#F8F8F8'}}>
            {
              classList.length > 0 ? <>
                <div className={styles['class-list'] + ' ' + `${pageType === '5' ? styles['class-list-5'] : ''}`}>
                  <span className={styles['title']}>{intl.formatMessage({id: '零件分类'})}：</span>
                  <span 
                    className={selClass === '' ? `${styles['class-item']} ${styles['active']}` : styles['class-item']}
                    style={{color: selClass === '' ? colorPrimary : '#333333', borderColor: selClass === '' ? colorPrimary : 'transparent'}}
                    onClick={() => selClassChange('')}
                  >{intl.formatMessage({ id: '全部' })}</span>
                  {
                    classList.map((item: any, index: number) => {
                      return (
                        <span 
                          key={index} 
                          className={selClass === item ? `${styles['class-item']} ${styles['active']}` : styles['class-item']}
                          style={{color: selClass === item ? colorPrimary : '#333333', borderColor: selClass === item ? colorPrimary : 'transparent'}}
                          onClick={() => selClassChange(item)}
                        >{capitalizeFirstLetter(item)}</span>
                      )
                    })
                  }
                </div>
                {
                  hasSecondClass ? (
                    <div className={styles['class-list'] + ' ' + `${pageType === '5' ? styles['class-list-5'] : ''}`} style={{ borderTop: '1px dashed #E0E0E0' }}>
                      <span className={styles['title']}>{intl.formatMessage({id: '二级分类'})}：</span>
                      <span 
                        className={secondClass === '' ? `${styles['class-item']} ${styles['active']}` : styles['class-item']}
                        style={{color: secondClass === '' ? colorPrimary : '#333333', borderColor: secondClass === '' ? colorPrimary : 'transparent'}}
                        onClick={() => secondClassChange('')}
                      >{intl.formatMessage({ id: '全部' })}</span>
                      {
                        (groupClass[selClass] || []).map((item: any, index: number) => {
                          // if(from === 'cjh' && !tagNams.includes(item)) return null
                          return (
                            <span 
                              key={index} 
                              className={secondClass === item ? `${styles['class-item']} ${styles['active']}` : styles['class-item']}
                              style={{color: secondClass === item ? colorPrimary : '#333333', borderColor: secondClass === item ? colorPrimary : 'transparent'}}
                              onClick={() => secondClassChange(item)}
                            >{capitalizeFirstLetter(item)}</span>
                          )
                        })
                      }
                    </div>
                  ): null
                }
              </> : null
            }
            {
              !isCst  ? <div className={styles['class-list']} style={{ borderTop: '1px dashed #E0E0E0' }}>
                <span className={styles['title']}>{intl.formatMessage({id: '自定义标签'})}：</span>
                <div className={styles['wrap-brand-list'] + ' ' + `${pageType === '5' ? styles['wrap-brand-list-5'] : ''}`} style={{ maxHeight: is_down ? `${pageType === '5' ? '40px' : '82px'}` : `${pageType === '5' ? '184px' : '162px'}` }}>
                  <div className={styles['brand-list'] + ' ' + `${pageType === '5' ? styles['brand-list-5'] : ''}`} style={{ overflow: is_down ? 'hidden' : 'scroll', maxHeight: is_down ? 80: '' }}>
                    <div 
                      className={styles['brand-item'] + ' ' +  `${!activeFbrand[0] ? styles['active'] : ''}` } 
                      onClick={() => { handleFbrand({ name: '', logo_url: '' }) }}
                      style={{color: !activeFbrand[0] ? colorPrimary : '#333333', borderColor: !activeFbrand[0] ? colorPrimary : '#E0E0E0'}}
                      data-has-image={false}
                    >
                      <span >{intl.formatMessage({ id: '全部' })}</span>
                      
                      {
                        !activeFbrand[0]  ? (pageType === '5' || pageType === '6' ? <i className={styles['selected'] + " icon iconfont icon-xuanzhong"} style={{fontSize: 16, color: colorPrimary}}></i> : <img className={styles['selected']} src={brandSelected} />) : null
                      }
                    </div>
                    {
                      fbrandList.map((item: any, index: number) => {
                        // if(from === 'cjh' && !tagNams.includes(item.name)) return null
                        return (
                          <div 
                            key={index} 
                            onClick={() => { handleFbrand(item) }} 
                            className={activeFbrand[0] && activeFbrand[0] === item.name ? `${styles['brand-item']} ${styles['active']} ${item.logo_url ? styles['has-image'] : styles['no-image']}` : `${styles['brand-item']} ${item.logo_url ? styles['has-image'] : styles['no-image']}`}
                            style={{color: activeFbrand[0] && activeFbrand[0] === item.name ? colorPrimary : '#333333', borderColor:  activeFbrand[0] && activeFbrand[0] === item.name ? colorPrimary : '#E0E0E0'}}
                            data-has-image={!!item.logo_url}
                          >
                            {item.logo_url && (
                              <img 
                                src={item.logo_url} 
                                className={styles['logo']}
                                alt={item.name} 
                                style={{ height: "30px" }}
                              />
                            )}
                            <span className={styles['name']}>{capitalizeFirstLetter(item.name) || intl.formatMessage({ id: '全部' })}</span>
                            {
                              activeFbrand[0] && activeFbrand[0] === item.name ? <i className={styles['selected'] + " icon iconfont icon-xuanzhong"} style={{fontSize: 16, color: colorPrimary}}></i> : null
                            }
                          </div>
                        )
                      })
                    }
                  </div>
                  <div className={styles['tools']}>
                    {
                      is_down ? (
                        <div className={styles['tools-item']} style={{color: colorPrimary}} onClick={() => set_is_down(false)}>
                          <span className='mr5 pointer'>{intl.formatMessage({ id: '更多' })}</span>
                          <i className='iconfont icon-down pointer' style={{ opacity: .6, fontSize: 14 }} />
                        </div>
                      ): (
                        <div className={styles['tools-item']} style={{color: colorPrimary}} onClick={() => set_is_down(true)}>
                          <span className='mr5 pointer'>{intl.formatMessage({ id: '收起' })}</span>
                          <i className='iconfont icon-up pointer' style={{ opacity: .6, fontSize: 14 }} />
                        </div>
                      )
                    }
                  </div>
                </div>
              </div> : null
            }
          </div>
          
          <div className='flex ptb10 plr10 mb10 mt10' style={{ fontSize: 12, color: '#333333', background: '#fff', height: selectArr.length > 32 ? (isMore ? 'max-content' : '80px') : 'max-content', overflow: 'hidden' }}>
            <div style={{lineHeight: '17px'}}>{intl.formatMessage({ id: '查询结果' })}：</div>
            <div className='flex-s-c' style={{ flexWrap: 'wrap', width: selectArr.length > 32 ? 'calc(100% - 100px)' : 'calc(100% - 70px)' }}>
              <div onClick={() => setSelectA("")} className='mr10 pointer' style={{ background: selectA === "" ? `${pageType === '5' ? colorPrimary : "#096BED"}` : '', color: selectA === "" ? (fontColorPrimary ? fontColorPrimary : "#ffffff" ): '#333333', padding: '2px 5px' }}>{intl.formatMessage({ id: '全部' })}</div>
              {
                selectArr.map((it: any, i: number) => {
                  return (
                    <div onClick={() => setSelectA(it)} className='mr10 pointer' key={i} style={{ background: selectA === it ? `${pageType === '5' ? colorPrimary : "#096BED"}` : '', color: selectA === it ? (fontColorPrimary ? fontColorPrimary : "#ffffff") : '#333333', padding: '2px 5px' }} >{it}</div>
                  )
                })
              }
            </div>
            {
              selectArr.length > 32 ? <span style={{cursor: 'pointer', color: '#096BED'}} onClick={() => setIsMore(!isMore)}>{intl.formatMessage({id: '更多'})}</span> : null
            }
          </div>
          <div className={styles['list-wrap']}>
            <div className={styles['list-head']}>
              <div className={styles['head-lf']}>
                <Radio.Group onChange={sortTypeChange} value={sortType}>
                  <Radio value='default'>{intl.formatMessage({id: '推荐排序'})}</Radio>
                  <Radio value='highToLow'>{intl.formatMessage({id: '价格由高到低'})}</Radio>
                  <Radio value='lowToHigh'>{intl.formatMessage({id: '价格由低到高'})}</Radio>
                </Radio.Group> 
                <Input.Search 
                allowClear
                placeholder={intl.formatMessage({id: '搜索零件名称'})}
                style={{width: 206, marginLeft: lang === 'ara' ? 0 : 30, marginRight: lang === 'ara' ? 30 : 0}} 
                value={partKey} 
                onChange={e => setPartKey(e.target.value)}
                onSearch={(value) => setPartKeyword(value)}
                />
              </div>
              <div className={styles['head-rt']}>
                <span className={styles['total']}>{intl.formatMessage({ id: '总共' })}：{pager.total}</span>
                <div style={{ display: 'flex' }}>
                  {/* <span className={styles['type-item']} onClick={() => setListType('space')}>
                    {
                      listType === 'space' ? <img src={spaceListSelected} alt="" /> : <img src={spaceListDefault} alt="" />
                    }
                  </span>
                  <span className={styles['type-item']} onClick={() => setListType('text')}>
                    {
                      listType === 'text' ? <img src={textListSelected} alt="" /> : <img src={textListDefault} alt="" />
                    }
                  </span> */}
                  <ConfigProvider
                    theme={{
                      components: {
                        Segmented: {
                          /* 这里是你的组件 token */
                          itemActiveBg: colorPrimary,
                          itemHoverBg: colorPrimary,
                          itemSelectedBg: colorPrimary,
                          itemHoverColor: fontColorPrimary ? fontColorPrimary : '#ffffff',
                          itemSelectedColor: fontColorPrimary ? fontColorPrimary : '#ffffff'
                        },
                      }
                    }}
                  >
                    <Segmented
                      value={listType}
                      onChange={(value) => setListType(value)}
                      options={[
                        { value: 'space', icon: <AppstoreOutlined /> },
                        { value: 'text', icon: <BarsOutlined /> },
                      ]}
                    />
                  </ConfigProvider>
                  
                </div>
              </div>
            </div>
            <Spin spinning={loading} delay={1000} indicator={<img src="https://cdns.007vin.com/img/autorepair/cst/car_loading.gif"/>} wrapperClassName={styles['list-spin']}>
              <div ref={spacelistRef}>
                {
                  _part_list.length ? <div>
                    {
                      listType === 'space' ? <>
                        {
                          commonStore.pageType === '5' || commonStore.pageType === '10' ? (
                            <div className='flex-s-c p5' style={{ flexWrap: 'wrap' }} >
                              {
                                _part_list.map((item: any, index: number) => {
                                  let dbj = token && (!item.quality_price || !item.goods_stock_num || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? true : false
                                  return (
                                    <Fragment key={index}>
                                      {
                                        item.type === 2 ? <div key={index} className={styles['item5'] + ' m5'} onClick={() => toPartDtl(item)}>
                                          {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                          <div className={styles['img-wrap5']}>
                                            <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                          </div>
                                          <div className={styles['item-b5'] + ' p10'}>
                                            <div>
                                              <div className={styles['part-name'] + ' b'}>
                                                <Tooltip title={item.part_name}>
                                                  <span>{item.part_name}</span>
                                                </Tooltip>
                                              </div>
                                              <div className={'color-8 mt10'}>
                                                {intl.formatMessage({id: '品牌'})}：{item.quality_name}
                                                
                                              </div>
                                              {
                                                showOe ? (
                                                  <div className={'color-8 mt10'}>
                                                    OE：
                                                    {
                                                      item.quality_oe ? <Copy icon={true} title={item.quality_oe} /> : null
                                                    }
                                                  </div>
                                                ): null
                                              }
                                              
                                              <div className='color-8 mt10' style={{height: 34, lineHeight: '17px'}}>
                                                <span>{intl.formatMessage({id: '商品编码'})}：</span><Copy icon={true} title={item.code} />
                                              </div>
                                              {
                                                commonStore.inventoryParams && commonStore.inventoryParams.stock_show ? <div className='color-8 mt10'>
                                                  {intl.formatMessage({id: '库存'})}：{item.goods_stock_num ? intl.formatMessage({id: '有货'}) : intl.formatMessage({id: '缺货'})}
                                                </div> : null
                                              }
                                              
                                            </div>
                                            {
                                              token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show && commonStore.shop_discount ? <div className='mt10'>
                                                <div className={styles['discount-boot']}>
                                                  <div className={styles['discount-wrap']}>
                                                    <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                    <div className={styles['price']}>
                                                      {priceUnit} &nbsp;
                                                      {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                    </div>
                                                  </div>
                                                  <div className={styles['origin-price'] + ' mt5'}>
                                                    {priceUnit} &nbsp;
                                                    {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                  </div>
                                                </div>
                                              </div> : <div className='mt10' style={{height: commonStore.shop_discount ? 38 : 'auto'}}>
                                                {
                                                  token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show ? <>
                                                    <span className={styles['price']}>
                                                      {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                    </span>
                                                    {
                                                      item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                    }
                                                  </> : null
                                                }
                                                {/* {
                                                  token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                                }
                                                {
                                                  !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                                } */}
                                                {
                                                  token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                                }
                                              </div>
                                            }
                                            
                                            
                                            <Button 
                                              onClick={(e: any) => addCart(e ,item)} 
                                              className='mt10' 
                                              style={{ width: '100%' }} 
                                              type="primary" 
                                              ghost 
                                              disabled={!dbj ? false : true}
                                              >{intl.formatMessage({ id: '加入购物车' })}</Button>
                                          </div>
                                        </div> : null
                                      }
                                      {
                                        item.type === 1 ? <div key={index} className={styles['item5'] + ' m5'} onClick={() => toPartDetail(item)}>
                                          {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                          <div className={styles['img-wrap5']}>
                                            <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                          </div>
                                          <div className={styles['item-b5'] + ' p10'}>
                                            <div>
                                              <div className={styles['part-name'] + ' b'}>
                                                <Tooltip title={item.label}>
                                                  <span>{item.label}</span>
                                                </Tooltip>
                                              </div>
                                              <div className={'color-8 mt10'}>
                                                {intl.formatMessage({id: '品牌'})}：{item.isDms ? item.quality_name : ''}
                                                
                                              </div>
                                              {
                                                showOe ? (
                                                  <div className={'color-8 mt10'}>
                                                    OE：
                                                    {
                                                      item.pid ? <Copy icon={true} title={item.pid} /> : null
                                                    }
                                                  </div>
                                                ): null
                                              }
                                              
                                              {/* <div className='color-8 mt10'>
                                                <span>{intl.formatMessage({id: '商品编码'})}：</span><Copy icon={true} title={item.code} />
                                              </div> */}
                                              {
                                                item.isDms && item.quality_name && commonStore.inventoryParams && commonStore.inventoryParams.stock_show ? <div className='color-8 mt10'>
                                                  {intl.formatMessage({id: '库存'})}：{item.goods_stock_num ? intl.formatMessage({id: '有货'}) : intl.formatMessage({id: '缺货'})}
                                                </div> : null
                                              }
                                              
                                            </div>
                                            {
                                              token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show && commonStore.shop_discount ? <div className='mt10'>
                                                <div className={styles['discount-boot']}>
                                                  <div className={styles['discount-wrap']}>
                                                    <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                    <div className={styles['price']}>
                                                      {priceUnit} &nbsp;
                                                      {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                    </div>
                                                  </div>
                                                  <div className={styles['origin-price'] + ' mt5'}>
                                                    {priceUnit} &nbsp;
                                                    {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                  </div>
                                                </div>
                                              </div> : <div className='mt10' style={{height: commonStore.shop_discount ? 38 : 'auto'}}>
                                                {
                                                  token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.inventoryParams && commonStore.inventoryParams.price_show ? <>
                                                    <span className={styles['price']}>
                                                      {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                    </span>
                                                    {
                                                      item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                    }
                                                  </> : null
                                                }
                                                {/* {
                                                  token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                                }
                                                {
                                                  !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                                } */}
                                                {
                                                  token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                                }
                                                
                                              </div>
                                            }
                                            <Button 
                                              className='mt10' 
                                              style={{ width: '100%' }}
                                              icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                              type="primary"
                                              onClick={(e) => openAsstModal(e, {
                                                part_name: item.label,
                                                oe: item.pid ? item.pid : '',
                                                amount: item.goods_stock_num ? item.goods_stock_num : 1
                                              })}
                                            >
                                              {intl.formatMessage({ id: '加需求' })}
                                            </Button>
                                            
                                            {/* <Button onClick={(e: any) => addCart(e ,item)} className='mt10' style={{ width: '100%' }} type="primary" ghost>{intl.formatMessage({ id: '加入购物车' })}</Button> */}
                                          </div>
                                        </div> : null
                                      }
                                      {
                                        item.type === 0 ? <div key={index} className={styles['item5'] + ' m5'} onClick={() => toPidDtl(item)}>
                                          {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                          <div className={styles['img-wrap5']}>
                                            <img src="https://cdns.007vin.com/img/autorepair/cst/no_item.png" alt="" />
                                          </div>
                                          <div className={styles['item-b5'] + ' p10'}>
                                            <div>
                                              <div className={styles['part-name'] + ' b'}>
                                                <Tooltip title={item.label}>
                                                  <span>{item.label}</span>
                                                </Tooltip>
                                              </div>
                                              {/* <div className={'color-8 mt10'}>
                                                {intl.formatMessage({id: '品牌'})}：{intl.formatMessage({id: '询价'})}
                                                
                                              </div> */}
                                              {
                                                showOe ? (
                                                  <div className={'color-8 mt10'}>
                                                    OE：
                                                    {
                                                      item.pid ? <Copy icon={true} title={item.pid} /> : null
                                                    }
                                                  </div>
                                                ): null
                                              }
                                              
                                              {/* <div className='color-8 mt10'>
                                                <span>{intl.formatMessage({id: '商品编码'})}：</span><Copy icon={true} title={item.code} />
                                              </div> */}
                                              {/* {
                                                commonStore.inventoryParams && commonStore.inventoryParams.stock_show ? <div className='color-8 mt10'>
                                                  {intl.formatMessage({id: '库存'})}：{item.goods_stock_num ? intl.formatMessage({id: '有货'}) : intl.formatMessage({id: '缺货'})}
                                                </div> : null
                                              } */}
                                              
                                            </div>
                                            <div className='mt10' style={{height: commonStore.shop_discount ? 38 : 'auto'}}>
                                              {/* <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> */}
                                            </div>
                                            
                                            {/* <Button onClick={(e: any) => addCart(e ,item)} className='mt10' style={{ width: '100%' }} type="primary" ghost disabled={item.goods_stock_num ? false : true}>{intl.formatMessage({ id: '加入购物车' })}</Button> */}
                                            <Button 
                                              className='mt10' 
                                              style={{ width: '100%' }}
                                              icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                              type="primary"
                                              onClick={(e) => openAsstModal(e, {
                                                part_name: item.label,
                                                oe: item.pid ? item.pid : '',
                                                amount: item.goods_stock_num ? item.goods_stock_num : 1
                                              })}
                                            >
                                              {intl.formatMessage({ id: '加需求' })}
                                            </Button>
                                          </div>
                                        </div> : null
                                      }
                                    </Fragment>
                                  )
                                })
                              }
                            </div>
                          ) : <div className={styles['space-list']} style={{ padding: 5 }}>
                            {
                              _part_list.map((item: any, index: number) => {
                                let dbj = token && (!item.quality_price || !item.goods_stock_num || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? true : false
                                return (
                                  <Fragment key={index}>
                                    {
                                      item.type === 2 ? <div className={styles['item1']}  style={{width: itemWidth }} onClick={() => toPartDtl(item)}>
                                        <div className={styles['img-wrap']}>
                                          <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                          {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                        </div>
                                        <div className={styles['item-b']}>
                                          <div className={styles['row2']} style={{marginBottom: 16}}>
                                            <span className={styles['brand']}>{item.quality_name}</span>
                                            <span className={styles['name']}>{item.part_name}</span>
                                            {
                                              item.is_replace ? <img src={replaceIcon} className={styles['replace-icon']} alt="" /> : null
                                            }
                                          </div>
                                          {
                                            item.code ? (
                                              <div className={styles['row2']} style={{marginBottom: 16}}>
                                                <div className='flex-s-c flex-wrap' style={{ color: '#333333', fontSize: 14 }}>
                                                  <span>{intl.formatMessage({id: '商品编码'})}：</span>
                                                  <span>
                                                    <Copy icon={true} title={item.code} />
                                                  </span>
                                                </div>
                                              </div>
                                            ): null
                                          }
                                          <div className={styles['row2']} style={{marginBottom: 16}}>
                                            {
                                              item.quality_oe ? <img src={oeIcon} alt="" /> : null
                                            }
                                            <span className={styles['oe']}>
                                              {
                                                item.quality_oe ? <Copy icon={true} title={item.quality_oe} /> : null
                                              }
                                            </span>
                                          </div>
                                          {
                                            token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.shop_discount ? <div className={styles['row1']}>
                                              <div className={styles['discount-boot']}>
                                                <div className={styles['discount-wrap']}>
                                                  <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                  <div className={styles['price']}>
                                                    {priceUnit} &nbsp;
                                                    {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                  </div>
                                                </div>
                                                <div className={styles['origin-price'] + ' mt5'}>
                                                  {priceUnit} &nbsp;
                                                  {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                </div>
                                              </div>
                                              {/* <img 
                                                src={cartPng} 
                                                style={{ width: 25, cursor: 'pointer' }} 
                                                onClick={(e: any) => addCart(e ,item)} 
                                              /> */}
                                              <Button 
                                                onClick={(e: any) => addCart(e ,item)} 
                                                className='mt10' 
                                                style={{ width: 32, color: colorPrimary, opacity: !dbj ? 1 : 0.8 }} 
                                                type="text" 
                                                icon={<i className='icon iconfont icon-jiarugouwuche'/>}
                                                disabled={!dbj ? false : true}
                                              ></Button>
                                            </div> : <div className={styles['row1']}>
                                              {
                                                token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <div style={{display: 'flex', alignItems: 'center'}}>
                                                  <span className={styles['price']}>
                                                    {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                  </span>
                                                  {
                                                    item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                  }
                                                </div> : null
                                              }
                                              {/* {
                                                token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) ? <span className={styles['quoted']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                              }
                                              {
                                                !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                              } */}
                                              {
                                                token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                              }
                                              {
                                                item.pay_count > 0 ? <span className={styles['pay-count']}>
                                                  {item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}
                                                </span> : null
                                              }
                                              {/* <img src={cartPng} style={{ width: 25, cursor: 'pointer' }} onClick={(e: any) => addCart(e ,item)} /> */}
                                              <Button 
                                                onClick={(e: any) => addCart(e ,item)} 
                                                className='mt10' 
                                                style={{ width: 32, color: colorPrimary, opacity: !dbj ? 1 : 0.8 }}
                                                type="text" 
                                                icon={<i className='icon iconfont icon-jiarugouwuche'/>}
                                                disabled={!dbj ? false : true}
                                              ></Button>
        
                                            </div>
                                          }
                                          
                                        </div>
                                      </div> : null
                                    }
                                    {
                                      item.type === 1 ? <div className={styles['item1']} style={{width: itemWidth }} onClick={() => toPartDetail(item)}>
                                        <div className={styles['img-wrap']}>
                                          <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                          {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                        </div>
                                        <div className={styles['item-b']}>
                                          <div className={styles['row2']} style={{marginBottom: 16}}>
                                            {
                                              item.isDms ? <span className={styles['brand']}>{item.quality_name}</span> : null
                                            }
                                            <span className={styles['name']}>{item.label}</span>
                                            {
                                              item.is_replace ? <img src={replaceIcon} className={styles['replace-icon']} alt="" /> : null
                                            }
                                          </div>
                                          {
                                            item.code ? (
                                              <div className={styles['row2']} style={{marginBottom: 16}}>
                                                <div className='flex-s-c flex-wrap' style={{ color: '#333333', fontSize: 14 }}>
                                                  <span>{intl.formatMessage({id: '商品编码'})}：</span>
                                                  <span>
                                                    <Copy icon={true} title={item.code} />
                                                  </span>
                                                </div>
                                              </div>
                                            ): null
                                          }
                                          <div className={styles['row2']} style={{marginBottom: 16}}>
                                            {
                                              item.pid ? <img src={oeIcon} alt="" /> : null
                                            }
                                            <span className={styles['oe']}>{item.pid}</span>
                                          </div>
                                          {
                                            token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.shop_discount ? <div className={styles['row1']}>
                                              <div className={styles['discount-boot']}>
                                                <div className={styles['discount-wrap']}>
                                                  <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                  <div className={styles['price']}>
                                                    {priceUnit} &nbsp;
                                                    {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                  </div>
                                                </div>
                                                <div className={styles['origin-price'] + ' mt5'}>
                                                  {priceUnit} &nbsp;
                                                  {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                </div>
                                              </div>
                                            </div> : <div className={styles['row1']}>
                                              {
                                                token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <div style={{display: 'flex', alignItems: 'center'}}>
                                                  <span className={styles['price']}>
                                                    {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                  </span>
                                                  {
                                                    item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                  }
                                                </div> : null
                                              }
                                              {/* {
                                                token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) ? <span className={styles['quoted']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                              } */}
                                              {
                                                token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                              }
                                              {/* <img src={cartPng} style={{ width: 25, cursor: 'pointer' }} onClick={(e: any) => addCart(e ,item)} /> */}
                                              <Button 
                                                icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                                type="primary"
                                                onClick={(e) => openAsstModal(e, {
                                                  part_name: item.label,
                                                  oe: item.pid ? item.pid : '',
                                                  amount: item.goods_stock_num ? item.goods_stock_num : 1
                                                })}
                                              >
                                                {intl.formatMessage({ id: '加需求' })}
                                              </Button>
                                            </div>
                                          }
                                          
                                        </div>
                                      </div> : null
                                    }
                                    {
                                      item.type === 0 ? <div className={styles['item1']} style={{width: itemWidth}} onClick={() => toPidDtl(item)}>
                                        <div className={styles['img-wrap']}>
                                          <img src="https://cdns.007vin.com/img/autorepair/cst/no_item.png" alt="" />
                                          {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                        </div>
                                        <div className={styles['item-b']}>
                                          <div className={styles['row2']} style={{marginBottom: 16}}>
                                            {/* <span className={styles['brand-1']}>{intl.formatMessage({id: '询价'})}</span> */}
                                            <span className={styles['name']}>{item.label}</span>
                                            {
                                              item.is_replace ? <img src={replaceIcon} className={styles['replace-icon']} alt="" /> : null
                                            }
                                          </div>
                                          <div className={styles['row2']} style={{marginBottom: 16}}>
                                            {
                                              item.pid ? <img src={oeIcon} alt="" /> : null
                                            }
                                            <span className={styles['oe-1']}>{item.pid}</span>
                                          </div>
                                          <div className={styles['row1']}>
                                            {/* <span className={styles['quoted']}>{intl.formatMessage({id: '待报价'})}</span> */}
                                            {/* <img src={cartPng} style={{ width: 25, cursor: 'pointer' }} onClick={(e: any) => addCart(e ,item)} /> */}
                                            <Button 
                                              icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                              type="primary"
                                              onClick={(e) => openAsstModal(e, {
                                                part_name: item.label,
                                                oe: item.pid ? item.pid : '',
                                                amount: item.goods_stock_num ? item.goods_stock_num : 1
                                              })}
                                            >
                                              {intl.formatMessage({ id: '加需求' })}
                                            </Button>
                                          </div>
                                          
                                        </div>
                                      </div> : null
                                    }
                                  </Fragment>
                                )
                              })
                            }
                          </div>
                        }
                      </> : <>
                        {
                          commonStore.pageType === '5' || commonStore.pageType === '10' ? (
                            <div className={styles['table-list']}>
                              <div className={styles['table-list-header'] + ' plr10'}>
                                <span style={{ width: '10%'  }}>{intl.formatMessage({ id: '图片' })}</span>
                                <span style={{ width: '20%'  }}>{intl.formatMessage({ id: '零件编码' })}</span>
                                <span style={{ width: '20%'  }}>{intl.formatMessage({ id: '配件信息' })}</span>
                                <span style={{ width: '15%'  }}>{intl.formatMessage({ id: '价格' })}</span>
                                <span style={{ width: '15%'  }}>{intl.formatMessage({ id: '库存' })}</span>
                                <span style={{ width: '20%', textAlign: 'center'  }}>{intl.formatMessage({ id: '操作' })}</span>
                              </div>
                              <div className={styles['table-list-body']}>
                                {
                                  _part_list.map((item: any, index: number) => {
                                    let dbj = token && (!item.quality_price || !item.goods_stock_num || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? true : false
                                    return (
                                      <Fragment key={index}>
                                        {
                                          item.type === 2 ? <div className={styles['item5-1']} onClick={() => toPartDtl(item)}>
                                            <div  style={{ width: '10%', position: 'relative' }}>
                                              <img style={{ width: 70, height: 70, border: '1px solid #F0F0F0' }} src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                              {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                            </div>
                                            <div style={{ width: '20%' }}>
                                              <p>{intl.formatMessage({ id: '商品编码' })}：<Copy icon={true} title={item.code} /></p>
                                              <p className='mt5'>
                                                {intl.formatMessage({ id: '原厂OE' })}：
                                                {
                                                  item.quality_oe ? <Copy icon={true} title={item.quality_oe} /> : null
                                                }
                                              </p>
                                            </div>
                                            <div style={{ width: '20%' }}>
                                              <p className='b'>{item.quality_name}·{item.part_name}</p>
                                              {
                                                item.warranty ? <p className='mt5'>{item.warranty}</p> : null
                                              }
                                            </div>
                                            <div style={{ width: '15%' }}>
                                              {
                                                token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.shop_discount ? <div className={styles['discount-boot']}>
                                                  <div className={styles['discount-wrap']}>
                                                    <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                    <div className={styles['price']}>
                                                      {priceUnit} &nbsp;
                                                      {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                    </div>
                                                  </div>
                                                  <div className={styles['origin-price'] + ' mt5'}>
                                                    {priceUnit} &nbsp;
                                                    {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                  </div>
                                                </div> : <p>
                                                  {
                                                    token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <div style={{display: 'flex', alignItems: 'center'}}>
                                                      <span className={styles['price']}>
                                                        {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                      </span>
                                                      {
                                                        item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                      }
                                                    </div> : null
                                                  }
                                                  {/* {
                                                    token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                                  }
                                                  {
                                                    !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                                  } */}
                                                  {
                                                    token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                                  }
                                                </p>
                                              }
                                              

                                            </div>
                                            <div style={{ width: '15%' }}>
                                              {/* {intl.formatMessage({ id: '库存充足' })} */}
                                            </div>
                                            <div style={{ width: '20%' }}>
                                              <Button 
                                                onClick={(e: any) => addCart(e ,item)} 
                                                type="primary" 
                                                ghost 
                                                style={{ width: '100%' }} 
                                                disabled={!dbj ? false : true}
                                              >{intl.formatMessage({ id: '加入购物车' })}</Button>
                                              <p  className='color-8 mt5'>
                                                {
                                                  item.pay_count > 0 ? <span className={styles['pay-count']}>
                                                    {item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}
                                                  </span> : null
                                                }
                                              </p>
                                            </div>
                                          </div> : null
                                        }
                                        {
                                          item.type === 1 ? <div className={styles['item5-1']} onClick={() => toPartDetail(item)}>
                                            <div  style={{ width: '10%', position: 'relative' }}>
                                              <img style={{ width: 70, height: 70, border: '1px solid #F0F0F0' }} src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                              {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                            </div>
                                            <div style={{ width: '20%' }}>
                                              <p>{intl.formatMessage({ id: '商品编码' })}：<Copy icon={true} title={item.code} /></p>
                                              <p className='mt5'>
                                                {intl.formatMessage({ id: '原厂OE' })}：{item.pid}
                                              </p>
                                            </div>
                                            <div style={{ width: '20%' }}>
                                              <p className='b'>{item.isDms ? item.quality_name : ''}·{item.label}</p>
                                              {
                                                item.warranty ? <p className='mt5'>{item.warranty}</p> : null
                                              }
                                            </div>
                                            <div style={{ width: '15%' }}>
                                              {
                                                token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.shop_discount ? <div className={styles['discount-boot']}>
                                                  <div className={styles['discount-wrap']}>
                                                    <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                    <div className={styles['price']}>
                                                      {priceUnit} &nbsp;
                                                      {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                    </div>
                                                  </div>
                                                  <div className={styles['origin-price'] + ' mt5'}>
                                                    {priceUnit} &nbsp;
                                                    {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                  </div>
                                                </div> : <p>
                                                  {
                                                    token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <div style={{display: 'flex', alignItems: 'center'}}>
                                                      <span className={styles['price']}>
                                                        {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                      </span>
                                                      {
                                                        item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                      }
                                                    </div> : null
                                                  }
                                                  {/* {
                                                    token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) ? <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                                  }
                                                  {
                                                    !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                                  } */}
                                                  {
                                                    token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                                  }
                                                </p>
                                              }
                                            </div>
                                            <div style={{ width: '15%' }}>
                                              {/* {intl.formatMessage({ id: '库存充足' })} */}
                                            </div>
                                            <div style={{ width: '20%' }}>
                                              {/* <Button onClick={(e: any) => addCart(e ,item)} type="primary" ghost style={{ width: '100%' }}>{intl.formatMessage({ id: '加入购物车' })}</Button> */}
                                              <Button 
                                                className='mt10' 
                                                style={{ width: '100%' }}
                                                icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                                type="primary"
                                                onClick={(e) => openAsstModal(e, {
                                                  part_name: item.label,
                                                  oe: item.pid ? item.pid : '',
                                                  amount: item.goods_stock_num ? item.goods_stock_num : 1
                                                })}
                                              >
                                                {intl.formatMessage({ id: '加需求' })}
                                              </Button>
                                              <p  className='color-8 mt5'>
                                                {
                                                  item.pay_count > 0 ? <span className={styles['pay-count']}>
                                                    {item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}
                                                  </span> : null
                                                }
                                              </p>
                                            </div>
                                          </div> : null
                                        }
                                        {
                                          item.type === 0 ? <div className={styles['item5-1']} onClick={() => toPidDtl(item)}>
                                            <div  style={{ width: '10%', position: 'relative' }}>
                                              <img style={{ width: 70, height: 70, border: '1px solid #F0F0F0' }} src="https://cdns.007vin.com/img/autorepair/cst/no_item.png" alt="" />
                                              {/* <div className={styles['from-oe']}>{item.search_oe}</div> */}
                                            </div>
                                            <div style={{ width: '20%' }}>
                                              <p>{intl.formatMessage({ id: '商品编码' })}：<Copy icon={true} title={item.pid} /></p>
                                              <p className='mt5'>
                                                {intl.formatMessage({ id: '原厂OE' })}：{item.pid}
                                              </p>
                                            </div>
                                            <div style={{ width: '20%' }}>
                                              <p className='b'>{item.label}</p>
                                              {
                                                item.warranty ? <p className='mt5'>{item.warranty}</p> : null
                                              }
                                            </div>
                                            <div style={{ width: '15%' }}>
                                              <p>
                                                {/* <span className={styles['no-price-0']}>{intl.formatMessage({id: '待报价'})}</span> */}
                                              </p>

                                            </div>
                                            <div style={{ width: '15%' }}>
                                              {/* {intl.formatMessage({ id: '库存充足' })} */}
                                            </div>
                                            <div style={{ width: '20%' }}>
                                              {/* <Button onClick={(e: any) => addCart(e ,item)} type="primary" ghost style={{ width: '100%' }} disabled={item.goods_stock_num ? false : true}>{intl.formatMessage({ id: '加入购物车' })}</Button> */}
                                              <Button 
                                                className='mt10' 
                                                style={{ width: '100%' }}
                                                icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                                type="primary"
                                                onClick={(e) => openAsstModal(e, {
                                                  part_name: item.label,
                                                  oe: item.pid ? item.pid : '',
                                                  amount: item.goods_stock_num ? item.goods_stock_num : 1
                                                })}
                                              >
                                                {intl.formatMessage({ id: '加需求' })}
                                              </Button>
                                              <p  className='color-8 mt5'>
                                                {
                                                  item.pay_count > 0 ? <span className={styles['pay-count']}>
                                                    {item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}
                                                  </span> : null
                                                }
                                              </p>
                                            </div>
                                          </div> : null
                                        }
                                      </Fragment>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          ) : <div className={styles['text-list'] + ' pl20 pr20'}>
                            {
                              _part_list.map((item: any, index: number) => {
                                let dbj = token && (!item.quality_price || !item.goods_stock_num || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show) ? true : false
                                return (
                                  <Fragment key={index}>
                                    {
                                      item.type === 2 ? <div className={styles['item2'] + ' pr20'}  onClick={() => toPartDtl(item)}>
                                        <div className={styles['item-lf']}>
                                          <div className={styles['img-wrap']}>
                                            <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                            {/* <div className={styles['from-oe']} style={{ left: 20 }}>{item.search_oe}</div> */}
                                          </div>
                                          <div>
                                            <div className={styles['row2'] + ' mb15'}>
                                              <span className={styles['brand']}>{item.quality_name}</span>
                                              <span className={styles['name']}>{item.part_name}</span>
                                              {
                                                item.is_replace ? <img src={replaceIcon} className={styles['replace-icon']} alt="" /> : null
                                              }
                                            </div>
                                            {
                                              item.code ? (
                                                <div className={styles['row2']} style={{marginBottom: 15}}>
                                                  <div className='flex-s-c flex-wrap' style={{ color: '#333333', fontSize: 14 }}>
                                                    <span>{intl.formatMessage({id: '商品编码'})}：</span>
                                                    <span>
                                                      <Copy icon={true} title={item.code} />
                                                    </span>
                                                  </div>
                                                </div>
                                              ): null
                                            }
                                            <div className={styles['row2'] + ' mb15'}>
                                              {
                                                item.quality_oe ? <img src={oeIcon} alt="" /> : null
                                              }
                                              <span className={styles['oe']}>
                                                {
                                                  item.quality_oe ? <Copy icon={true} title={item.quality_oe} /> : null
                                                }
                                              </span>
                                            </div>
                                            {
                                              token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) && commonStore.shop_discount ? <div className={styles['row2']}>
                                                <div className={styles['discount-boot']}>
                                                  <div className={styles['discount-wrap']}>
                                                    <div className={styles['price-title']}>{intl.formatMessage({id: '商城折扣价'})}</div>
                                                    <div className={styles['price']}>
                                                      {priceUnit} &nbsp;
                                                      {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price * (1 - commonStore.shop_discount)) : roundToTwo(item.quality_price * (1 - commonStore.shop_discount))}
                                                    </div>
                                                  </div>
                                                  <div className={styles['origin-price'] + ' mt5'}>
                                                    {priceUnit} &nbsp;
                                                    {commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                  </div>
                                                </div>
                                                {/* <img src={cartPng} style={{ width: 25, height: 'auto', cursor: 'pointer' }} onClick={(e: any) => addCart(e ,item)} /> */}
                                                <Button 
                                                  onClick={(e: any) => addCart(e ,item)} 
                                                  style={{ width: 32, color: colorPrimary, opacity: !dbj ? 1 : 0.8 }} 
                                                  type="text" 
                                                  icon={<i className='icon iconfont icon-jiarugouwuche'/>}
                                                  disabled={!dbj ? false : true}
                                                ></Button>
                                              </div> : <div className={styles['row2']}>
                                                {
                                                  token && item.quality_price && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 || commonStore.isVisitor === 1) ? <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <span className={styles['price']}>
                                                      {item.quality_price ? priceUnit : ''}&nbsp;{commonStore.currency_data && commonStore.currency_data.code && commonStore.currency_data.code === 'VND' ? formatVND(item.quality_price) : item.quality_price}
                                                    </span>
                                                    {
                                                      item.quality_price ? <CurrencyExrate money={item.quality_price} style={{marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}/> : null
                                                    }
                                                  </div> : null
                                                }
                                                {/* {
                                                  token && (!item.quality_price || (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) ? <span className={styles['no-price']}>{intl.formatMessage({id: '待报价'})}</span> : null
                                                }
                                                {
                                                  !token ? <span className={styles['no-price']}>{intl.formatMessage({id: '认证公司后显示价格'})}</span> : null
                                                } */}
                                                {
                                                  token && (!item.quality_price || (commonStore.inventoryParams && !commonStore.inventoryParams.price_show)) ? <span className={styles['no-price-0']} onClick={e => applyViewPrice(e, item)}>{intl.formatMessage({id: '申请查看价格'})}</span> : null
                                                }
                                                {
                                                  item.pay_count > 0 ? <span className={styles['pay-count']}>
                                                    {item.pay_count > 200 ? `200+${intl.formatMessage({ id: '付款' })}` : `${item.pay_count}+${intl.formatMessage({ id: '付款' })}`}
                                                  </span> : null
                                                }
                                                {/* <img src={cartPng} style={{ width: 25, height: 'auto', cursor: 'pointer' }} onClick={(e: any) => addCart(e ,item)} /> */}
                                                <Button 
                                                  onClick={(e: any) => addCart(e ,item)} 
                                                  style={{ width: 32, color: colorPrimary, opacity: !dbj ? 1 : 0.8 }}
                                                  type="text" 
                                                  icon={<i className='icon iconfont icon-jiarugouwuche'/>}
                                                  disabled={!dbj ? false : true}
                                                ></Button>
                                              </div>
                                            }
                                            
                                          </div>
                                        </div>
                                        <Button type="primary">{intl.formatMessage({id: '去看看'})}<ArrowRightOutlined /></Button>
                                      </div> : null
                                    }
                                    {
                                      item.type === 1 ? <div className={styles['item2'] + ' pr20'}  onClick={() => toPartDetail(item)}>
                                        <div className={styles['item-lf']}>
                                          <div className={styles['img-wrap']}>
                                            <img src={item.images ? item.images.split(',')[0] : (item.oe_image_info && item.oe_image_info.imagePath ? item.oe_image_info.imagePath : `https://cdns.007vin.com/img/autorepair/cst/no_item.png`)} alt="" />
                                            {/* <div className={styles['from-oe']} style={{ left: 20 }}>{item.search_oe}</div> */}
                                          </div>
                                          <div>
                                            <div className={styles['row2'] + ' mb15'}>
                                              {
                                                item.isDms ? <span className={styles['brand']}>{item.quality_name}</span> : <span className={styles['brand-1']}></span>
                                              }
                                              <span className={styles['name']}>{item.label}</span>
                                              {
                                                item.is_replace ? <img src={replaceIcon} className={styles['replace-icon']} alt="" /> : null
                                              }
                                            </div>
                                            {
                                              item.code ? (
                                                <div className={styles['row2']} style={{marginBottom: 15}}>
                                                  <div className='flex-s-c flex-wrap' style={{ color: '#333333', fontSize: 14 }}>
                                                    <span>{intl.formatMessage({id: '商品编码'})}：</span>
                                                    <span>
                                                      <Copy icon={true} title={item.code} />
                                                    </span>
                                                  </div>
                                                </div>
                                              ): null
                                            }
                                            <div className={styles['row2'] + ' mb15'}>
                                              {
                                                item.pid ? <img src={oeIcon} alt="" /> : null
                                              }
                                              <span className={styles['oe']}>{item.pid}</span>
                                            </div>
                                            <div className={styles['row2']}>
                                              {/* <span className={styles['quoted']}>{intl.formatMessage({id: '待报价'})}</span> */}
                                              <Button 
                                                icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                                type="primary"
                                                onClick={(e) => openAsstModal(e, {
                                                  part_name: item.label,
                                                  oe: item.pid ? item.pid : '',
                                                  amount: item.goods_stock_num ? item.goods_stock_num : 1
                                                })}
                                              >
                                                {intl.formatMessage({ id: '加需求' })}
                                              </Button>
                                            </div>
                                          </div>
                                        </div>
                                        <Button type="primary">{intl.formatMessage({id: '去看看'})}<ArrowRightOutlined /></Button>
                                        
                                      </div> : null
                                    }
                                    {
                                      item.type === 0 ? <div className={styles['item2'] + ' pr20'}  onClick={() => toPidDtl(item)}>
                                      <div className={styles['item-lf']}>
                                        <div className={styles['img-wrap']}>
                                          <img src={noOeImg} alt="" />
                                          {/* <div className={styles['from-oe']} style={{ left: 20 }}>{item.search_oe}</div> */}
                                        </div>
                                        <div>
                                          <div className={styles['row2'] + ' mb20'}>
                                            {/* <span className={styles['brand-1']}>{intl.formatMessage({id: '询价'})}</span> */}
                                            <span className={styles['name']}>{item.label}</span>
                                            {
                                              item.is_replace ? <img src={replaceIcon} className={styles['replace-icon']} alt="" /> : null
                                            }
                                          </div>
                                          <div className={styles['row2'] + ' mb20'}>
                                            {
                                              item.pid ? <img src={oeIcon} alt="" /> : null
                                            }
                                            <span className={styles['oe-1']}>{item.pid}</span>
                                          </div>
                                          <div className={styles['row2']}>
                                            {/* <span className={styles['quoted']}>{intl.formatMessage({id: '待报价'})}</span> */}
                                            {/* <img src={cartPng} style={{ width: 25, height: 'auto', cursor: 'pointer' }} onClick={(e: any) => addCart(e ,item)} /> */}
                                            <Button 
                                              icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} 
                                              type="primary"
                                              onClick={(e) => openAsstModal(e, {
                                                part_name: item.label,
                                                oe: item.pid ? item.pid : '',
                                                amount: item.goods_stock_num ? item.goods_stock_num : 1
                                              })}
                                            >
                                            {intl.formatMessage({ id: '加需求' })}
                                          </Button>
                                          </div>
                                        </div>
                                      </div>
                                      <Button type="primary">{intl.formatMessage({id: '去看看'})}<ArrowRightOutlined /></Button>
                                      
                                    </div> : null
                                    }
                                  </Fragment>
                                  
                                )
                              })
                            }
                          </div>
                        }
                      </>
                      
                    }
                    {/* {
                      ycOeList.length > 20 && ycOeList.length > oeAcIndex + 20 ? <div style={{textAlign: 'center', paddingBottom: 20}}>
                        <Button type="primary" ghost onClick={getMore}>加载更多</Button>
                      </div> : null
                    } */}
                    <div className={styles['pager']}>
                      <Pagination 
                        current={pager.page} 
                        total={pager.total} 
                        pageSize={pager.size}
                        pageSizeOptions={[50, 60, 120, 180]}
                        onChange={pagerChange}
                      />
                    </div>
                  </div> : <div>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={intl.formatMessage({id: '暂无数据'})}/>
                  </div>
                }
              </div>
            </Spin>
          </div>
        </div>
      }
      
      {
        supplementOpen ? (
          <Supplement
            companyInfo={commonStore.companyInfo}
            onCancel={() => setSupplementOpen(false)}
            onConfirm={() => {getUserInfo()}}
          />
        ): null
      }
      {
        asstShow ? (
          <PurchaseAsst
            open={asstShow}
            info={asstInfo}
            onCancel={() => {setAsstShow(false); setAsstInfo({});}}
          />
        ) : null
      }
    </div>
  )
}

const PurchaseAsst: React.FC<any> = (props) => {
  const { open=false, info={}, onCancel } = props
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { colorPrimary } = commonStore
  const intl = useIntl()
  const navigate = useNavigate()
  const [value, setValue] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if(info && open) {
      setValue({
        ...info,
        purchase_day: info.purchase_day ? info.purchase_day : intl.formatMessage({id: '无'}),
        remark: info.remark ? info.remark : '',
        images: Array.isArray(info.images) ? info.images : (info.images ? String(info.images).split(',').filter(Boolean) : [])
      })
    }
  }, [info, open, intl])
  
  const valueChange = (val: any, type: string) => {
    let _value = JSON.parse(JSON.stringify(value))
    _value[type] = val
    setValue(_value)
  }

  const toSubmit = () => {
    let images = Array.isArray(value.images) ? value.images : []
    setLoading(true)
    listApi.submitPurchaseAsst({
      ...value,
      images,
    }).then((res: any) => {
      if(res.code === 1) {
        message.success(intl.formatMessage({id: '操作成功！'}))
        getExquireNum()
        onCancel && onCancel()
        navigate(`/mine/requirementList`)
      }
      setLoading(false)
    }).catch((err: any) => {
      setLoading(false)
    })
  }
  const getExquireNum = () => {
    accountApi.getRequireList({
      page: 1,
      size: 10,
      keyword: ''
    }).then((res: any) => {
      if(res.code === 1) {
        let total = res.data && res.data.total ? res.data.total : 0
        setCommonStore({
          type: 'requireNum',
          value: total
        })
      }
    })
  }
  const toDemand = () => {
    navigate(`/mine/requirementList`)
    onCancel && onCancel()
  }
  const delImage = (index: number) => {
    let images = Array.isArray(value.images) ? [...value.images] : []
    images.splice(index, 1)
    valueChange(images, 'images')
  }

  return (
    <Modal
      open={open}
      title={intl.formatMessage({id: '采购助手'})}
      width={450}
      footer={null}
      onCancel={onCancel}
    >
      <div className={styles['asst-wrap']}>
        <div className={styles['asst-pop']}>{intl.formatMessage({id: 'Hi～尊敬的【{name}】我是采购小助手，为您匹配优质货源，您可以点击一键获取专属服务～'}, {name: commonStore.userInfo && commonStore.userInfo.repair_shop_name ? commonStore.userInfo.repair_shop_name : (commonStore.userInfo && commonStore.userInfo.phone ? commonStore.userInfo.phone : '')})}</div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i>*</i>
            {intl.formatMessage({id: '商品名称'})}
          </span>
          <Input style={{width: 180}} value={value.part_name} onChange={e => valueChange(e.target.value, 'part_name')}/>
        </div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i>*</i>
            {intl.formatMessage({id: 'OE号'})}
          </span>
          <Input style={{width: 180}} value={value.oe} onChange={e => valueChange(e.target.value, 'oe')}/>
        </div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i></i>
            {intl.formatMessage({id: '数量'})}
          </span>
          <InputNumber min={1} step={1} style={{width: 180}} value={value.amount} onChange={val => valueChange(val, 'amount')}/>
        </div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i></i>
            {intl.formatMessage({id: '期望到货时间'})}
          </span>
          <Select 
            style={{width: 180}} 
            options={[{
              label: intl.formatMessage({id: '无'}),
              value: intl.formatMessage({id: '无'})
            },{
              label: intl.formatMessage({id: '7天'}),
              value: intl.formatMessage({id: '7天'})
            },{
              label: intl.formatMessage({id: '15天'}),
              value: intl.formatMessage({id: '15天'})
            },{
              label: intl.formatMessage({id: '30天'}),
              value: intl.formatMessage({id: '30天'})
            },{
              label: intl.formatMessage({id: '90天'}),
              value: intl.formatMessage({id: '90天'})
            }]}
            value={value.purchase_day} 
            onChange={val => valueChange(val, 'purchase_day')}
          />
        </div>
        <div className={styles['item']}>
          <span className={styles['title']}>
            <i></i>
            {intl.formatMessage({id: '备注'})}
          </span>
          <Input style={{width: 180}} placeholder={intl.formatMessage({id: '备注'})} value={value.remark} onChange={e => valueChange(e.target.value, 'remark')}/>
        </div>
        <div className={styles['item'] + ' ' + styles['upload-item']}>
          <span className={styles['title']}>
            <i></i>
            {intl.formatMessage({id: '图片'})}
          </span>
          <div className={styles['asst-upload-wrap']}>
            <ObsImageUpload
              value={Array.isArray(value.images) ? value.images : []}
              onChange={(images: string[]) => valueChange(images, 'images')}
            />
            {
              Array.isArray(value.images) && value.images.length ? (
                <div className={styles['asst-img-list']}>
                  <Image.PreviewGroup>
                    {
                      value.images.map((item: string, index: number) => {
                        return (
                          <div className={styles['asst-img-item']} key={item + index}>
                            <Image src={item} alt="" width={72} height={62} style={{objectFit: 'cover'}} preview={{src: item}} />
                            <i className="iconfont icon-quxiao1" onClick={(e) => {e.stopPropagation(); delImage(index)}} />
                          </div>
                        )
                      })
                    }
                  </Image.PreviewGroup>
                </div>
              ) : null
            }
          </div>
        </div>
        <div className="mt30">
          <Button style={{width: '100%'}} icon={<i className='icon iconfont icon-tianjiaxuqiu'/>} type="primary" size="large" loading={loading} onClick={toSubmit}>{intl.formatMessage({id: '加需求'})}</Button>
        </div>
        <div className='pt10 pb10 center pointer' style={{color: colorPrimary}} onClick={toDemand}>
          {intl.formatMessage({id: '查看历史采购需求'})}
        </div>
      </div>
    </Modal>
  )
}
export default PidList

export { PurchaseAsst }
